/* eslint-disable no-unused-vars */
import { useState, useEffect, useContext, useRef } from "react";
import { Show, SimpleShowLayout, Toolbar, Button as RaButton } from "react-admin";
import {
	Button, Box, useMediaQuery, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, TableSortLabel,
	TablePagination, withStyles, Checkbox, Dialog, DialogContent, DialogActions, DialogContentText, TextField as MuiTextField,
	CircularProgress, FormControl, InputLabel, Select, MenuItem, List as MuiList, ListItem, ListItemAvatar, Avatar, ListItemText, Typography, Portal, Switch, Chip, Tooltip, RadioGroup, FormControlLabel, Radio, FormLabel, IconButton
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import moment from "moment";
import { customTheme } from './../customTheme';
import { vehicleSvgs, paymentModeColors, hideVehicleNumber } from "./../sharedData";
import ScrollableTable from '../components/ScrollableTable';
import ImageGalleryDialog from '../components/ImageGalleryDialog';
import { MoneyOff as MoneyOffIcon, AttachMoney as AttachMoneyIcon, Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";
import config from '../config.json';
import { stringify } from 'query-string';
import { saveTokens } from '../utils/saveTokens';
import notify from '../components/CustomUseNotify';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import DateTimePickerToolbar from "../components/DateTimePickerToolbar";
import CustomDateTimePicker from '../components/CustomDateTimePickerV4';
import { useLocation } from "react-router-dom";
import ParkingSearchSelector from '../components/ParkingSearchSelector';
import { useSelector } from 'react-redux';
import CustomSearch from '../components/CustomSearch';
import VehicleSummaryCard from "../components/VehicleSummaryCard";
import CustomFilter from '../components/CustomFilter';
import Skeleton from '@material-ui/lab/Skeleton';
import NewSummaryCard from "../components/NewSummaryCard";
import ReactApexChart from 'react-apexcharts';
import BrokenImageOutlinedIcon from '@material-ui/icons/BrokenImageOutlined';
import CctvImage from '../../src/images/cctv.svg';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
// import { Link } from "react-router-dom";
// import queryString from 'query-string';
import GetAppIcon from "@material-ui/icons/GetApp";
import { generateReport } from "../utils/generateReports";
import { Stack } from "@mui/material";
import ShowTimePeriod from '../components/ShowTimePeriod';
import VideocamIcon from '@material-ui/icons/Videocam';
import VideocamOffIcon from '@material-ui/icons/VideocamOff';
import sideArrow from '../images/white_side_arrow.png'
import CustomRowFilter from '../components/CustomRowFilter';
import { useHistory } from "react-router-dom";
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { ContextProvider } from '../globalContextProvider';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ImageGalleryDialogV2 from '../components/ImageGalleryDialogV2';
import AutoRefreshToggle from "../components/autoRefreshToggle";

const useStyles = makeStyles({
	timeFilterContainer: {
		alignItems: "center",
		marginTop: customTheme.spacing(5),
	},
	timeFilterInput: {
		marginLeft: "2%",
	},
	outlinedInput: {
		padding: 0,
	},
	timeFilterButton: {
		marginLeft: "1%",
		width: "10%",
		minWidth: 85
	},
	summaryListRoot: {
		marginTop: customTheme.spacing(2),
	},
	summaryCardContainer: {
		display: "grid",
		gridAutoFlow: "column",
		marginTop: customTheme.spacing(3),
	},
	flexContainer: {
		display: 'flex',
		alignItems: "center",
	},
	listActions: {
		justifyContent: "space-between",
		marginTop: customTheme.spacing(3),
	},
	mainTableCell: {
		color: `${customTheme.palette.grey[900]} !important`,
		fontWeight: 500,
	},
	listVehicleIcon: {
		width: 25,
		height: 25,
		marginRight: customTheme.spacing(1),
		verticalAlign: "middle",
	},
	chipCell: {
		textAlign: "center",
		padding: customTheme.spacing(1, 2),
		display: "inline-block",
		borderRadius: 50,
		position: "relative"
	},
	showLayoutMain: {
		marginTop: 0,
	},
	showTitle: {
		fontSize: 22,
	},
	searchParamsTitle: {
		fontSize: "1.05rem",
	},
	searchParams: {
		fontFamily: "Poppins-Regular",
		fontSize: "0.95rem",
	},
	parkingSelectorContainer: {
		display: "grid",
		justifyContent: "space-between",
	},
	asyncSelector: {
		display: "grid",
		gridAutoFlow: "column",
		justifyContent: "space-between",
		paddingRight: 5,
	},
	removeMargin: {
		margin: 0,
	},
	parkingListHead: {
		color: customTheme.palette.grey[500],
	},
	inlineForm: {
		display: "grid",
		gridAutoFlow: "column",
		padding: "18px 2%",
		marginLeft: 15
	},
	removeUnderline: {
		borderBottom: "none",
	},
	checkIconButton: {
		borderRadius: 4,
		padding: "5px 5px 2px",
		'&:hover': {
			backgroundColor: "#0001 !important",
			cursor: "pointer",
		},
	},
	smallSelectRoot: {
		padding: "10px 32px 10px 18px",
	},
	receiptTextContainer: {
		display: "flex",
		padding: "15px 20px",
		'&:hover': {
			backgroundColor: "#00336608",
		},
		alignItems: "center",
		marginBottom: 15,
		border: "1px solid #bfbfbf",
		borderRadius: 4,
	},
	selectWithIcon: {
		display: "flex",
		justifyContent: "space-between",
		paddingLeft: 20,
		paddingRight: "40px !important",
		columnGap: 30,
	},
	editSummaryTime: {
		color: "#888",
		fontSize: 20,
		marginLeft: 10,
		'&:hover': {
			cursor: "pointer",
			opacity: 0.7,
		}
	},
	dialogPaper: {
		borderRadius: 15,
		padding: "5px 15px 15px",
	},
	backDrop: {
		backgroundColor: "#00000042"
	},
	statusCircle: {
		width: 7,
		height: 7,
		borderRadius: 10,
	},
	columnLink: {
		display: 'flex',
		alignItems: 'center',
		'&:hover': {
			cursor: 'pointer',
		}
	},
});
const StyledTableCell = withStyles((theme) => ({
	root: {
		fontSize: 12,
		borderBottomColor: customTheme.palette.divider,
		padding: "15px 5px !important",
	},
	head: {
		fontWeight: 500,
		color: customTheme.palette.grey[700],
	},
	body: {
		fontWeight: 400,
		color: "#707683",
	},
}))(TableCell);

const SUMMARY_COLUMNS = {
	"Type": true,
	"Vehicle Number": true,
	"Amount": true,
	"Duration": true,
	"Entry": true,
	"Gate": true,
	"Time": true,
	"Payment": true,
	"Discount": true,
	"Device": true,
	"Exit": true,
	"Gate ": true,
	"Time ": true,
	"Payment ": true,
	"Discount ": true,
	"Device ": true,
	"Add On Service": true,
	"Ticket Number": true,
	"Mobile Number": false,
	// "Entry Time": true,
	// "Exit Time": true,
	// "Entry Amount": false,
	// "Exit Amount": false,
	"Lost Ticket Charges": false,
	// "Entry Payment Mode": true,
	// "Exit Payment Mode": true,
	// "Images": true,
	// "Entry Image": true,
	// "Exit Image": true,
	"NFC UID": false,
	"Serial Number": false,
	// "Category": true,
	// "Entry User": true,
	// "Exit User": true,
	// "FASTag Entry Status": true,
	// "FASTag Exit Status": true,
	"Remarks": false,
	"Day Pass": false,
	"Visit Reason": false,
	"Visit Destination": false,
	"Visit Area": true,
	"Customer Name": true,
	"Customer DOB": false,
	"Driving License": false,
	"Chassis": false,
	"Model": false,
	"Helmet Cost": true,
	"Violation": false
};
const CATEGORIES = {
	PAID: "Paid",
	FOC: "FOC",
	IDF: "Drop Off",
	UNPAID: "Unpaid"
};

const CATEGORIESNEW = {
	PAID: { label: "Paid", style: { color: "#18CC69", backgroundColor: "#18CC6919", borderRadius: 2 } },
	FOC: { label: "FOC", style: { color: "#5E8DD3", backgroundColor: "#5E8DD319", borderRadius: 2 } },
	IDF: { label: "Drop Off", style: { color: "#F7685B", backgroundColor: "#F7685B19", borderRadius: 2 } },
	UNPAID: { label: "Unpaid", style: { color: "#18CC69", backgroundColor: "#18CC6919", borderRadius: 2 } }
};

const FASTAG_STATUS = {
	"ACTIVE": { color: "#18CC69", backgroundColor: "#18CC6919" },
	"HOTLIST": { color: "#F7685B", backgroundColor: "#F7685B19" },
	"EXEMPT": { color: "#F7685B", backgroundColor: "#F7685B19" },
	"CLOSED": { color: "#F7685B", backgroundColor: "#F7685B19" },
	"BLACKLIST": { color: "#F7685B", backgroundColor: "#F7685B19" },
	"INVALID CARRIAGE": { color: "#F7685B", backgroundColor: "#F7685B19" },
	"LOW BALANCE": { color: "#F7685B", backgroundColor: "#F7685B19" },
	"DEFAULT": { color: "#F7685B", backgroundColor: "#F7685B19" },
};


const SEARCH_TYPES = ["Vehicle Number", "Serial Number"];
const VEHICLE_SUMMARY_STRUCTURE = {
	enteredVehicles: 0,
	enteredVehiclesPass: 0,
	enteredVehiclesVisitor: 0,
	exitedVehicles: 0,
	exitedVehiclesVisitor: 0,
	exitedVehiclesPass: 0,
	exitedVehiclesCurrentPeriod: 0,
	exitedVehiclesPreviousPeriod: 0,
	exitedVehiclesCurrentPeriodVisitor: 0,
	exitedVehiclesPreviousPeriodVisitor: 0,
	exitedVehiclesCurrentPeriodPass: 0,
	exitedVehiclesPreviousPeriodPass: 0,

	amount: 0,
	amountCurrentPeriod: 0,
	amountPreviousPeriod: 0,
	notExited: 0,
	vehicleTypes: {}
};
const getVehicleTypeCount = features => Object.keys(vehicleSvgs).filter(type => (!features || (features.vehicle_type[type] && features.vehicle_type[type].visible))).length;

function vehicleSummaryMaskHandler(value, type = "Count") {
	if (typeof value === "number") {
		value = value.toFixed(2);
		let trimCount = 0;
		if (value.charAt(value.length - 1) === "0") {
			trimCount = 1;
			if (value.charAt(value.length - 2) === "0") {
				trimCount = 3;
			}
		}
		value = value.substring(0, value.length - trimCount);
	}
	if (sessionStorage.getItem("vehicle_summary_mask") === "1") {
		let valueString = value.toString();
		if (valueString.includes(".")) {
			let [integerPart, decimalPart] = valueString.split(".");
			let integerPartLength = integerPart.length;
			let stars = "*".repeat(Math.max(0, integerPartLength - 2));
			let convertedIntegerPart = integerPart.slice(-2);
			if (integerPart.length === 1) {
				convertedIntegerPart = "*" + integerPart;
			}
			return stars + convertedIntegerPart + "." + decimalPart;
		} else if (valueString.length <= 2) {
			return "*".repeat(valueString.length);
		} else {
			return valueString.slice(0, -2) + "**";
		}
	} else return value
}

const VehicleSummary = ({ record = {} }) => {
	const classes = useStyles();
	const location = useLocation();
	const parkings = useSelector(state => state.parkings);
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const navigate = useHistory()
	const { setResetHeight } = useContext(ContextProvider);
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");
	const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [viewOnly] = useState(sessionStorage.getItem("view_only") === "1");
	const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
	const [prevSearch] = useState(sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : "");
	const [reduceSummary] = useState(isNaN(sessionStorage.getItem("reduce_summary")) || sessionStorage.getItem("reduce_summary") === '0' || sessionStorage.getItem("reduce_summary") === 0 ? '' : sessionStorage.getItem("reduce_summary"));

	const [vehicleTypes, setVehicleTypes] = useState({});
	const [vehicleTypesCount, setVehicleTypesCount] = useState(getVehicleTypeCount(record.features));
	const [showDayPassColumn, setShowDayPassColumn] = useState(false);

	const [currentParking, setCurrentParking] = useState(!parkings.loading ? { ...parkings.data.find(parking => parking.general_name === record.general_name), allZones: true } : { ...record, allZones: true });
	const [displayColumns, setDisplayColumns] = useState(localStorage.getItem("summaryColumns") ? JSON.parse(localStorage.getItem("summaryColumns")) : SUMMARY_COLUMNS);
	const [startDateTime, setStartDateTime] = useState(null);
	const [endDateTime, setEndDateTime] = useState(null);
	const [defaultCategoryFilter] = useState(sessionStorage.getItem("filter_category"));
	const [actionFilter, setActionFilter] = useState(null);
	const [vehicleFilter, setVehicleFilter] = useState(null);
	const [categoryToFilter, setCategoryToFilter] = useState(defaultCategoryFilter);
	const [paymentModeFilter, setPaymentModeFilter] = useState(null);
	const [filterListValue, setFilterListValue] = useState(null);
	const [entryPaymentModes, setEntryPaymentModes] = useState(null);
	const [exitPaymentModes, setExitPaymentModes] = useState(null);
	const [entryUser, setEntryUser] = useState(null);
	const [exitUser, setExitUser] = useState(null);
	const [entryPosDevice, setEntryPosDevice] = useState(null);
	const [exitPosDevice, setExitPosDevice] = useState(null);
	const [commercialVehicles, setCommercialVehicles] = useState(null);
	const [entryFastag, setEntryFastag] = useState(null);
	const [exitFastag, setExitFastag] = useState(null);
	const [durationFilter, setDurationFilter] = useState(null);

	const [vehicleSummary, setVehicleSummary] = useState(VEHICLE_SUMMARY_STRUCTURE);
	const [loadingVehicleSummary, setLoadingVehicleSummary] = useState(false);

	const [vehicles, setVehicles] = useState([]);
	const [totalVehicleCount, setTotalVehicleCount] = useState(0);
	const [loadingVehicles, setLoadingVehicles] = useState(true);
	// const [selectedRows, setSelectedRows] = useState({});
	// const selectedIds = Object.keys(selectedRows);
	const [selected, setSelected] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(25);
	const [rowsPerPageOptions] = useState(reduceSummary ? [25] : [25, 50, 100]);
	const [sortOrder, setSortOrder] = useState("DESC");
	const [sortBy, setSortBy] = useState("Exit Time");
	const [search, setSearch] = useState(prevSearch.inputSearch);
	const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : SEARCH_TYPES[0]);

	const [freeVehicleConfirmation, setFreeVehicleConfirmation] = useState(null);
	const lastThreeMonthsLimit = false
	const [allowCurrentVehiclesUpdate] = useState(sessionStorage.getItem("allow_current_vehicles_update") === "1");
	const [showPaymentTypeSummary, setShowPaymentTypeSummary] = useState(null)
	const [showTilesForEntered, setShowTilesForEntered] = useState(null)
	const [showTilesForExited, setShowTilesForExited] = useState(null)
	const [showFastagPayment] = useState(sessionStorage.getItem("show_fastag_payment") === "1");
	const [showPaidUnpaidAmount] = useState(sessionStorage.getItem("show_paid_unpaid_amount") === "1");
	const [showSeparateEntryExitImages] = useState(sessionStorage.getItem("separate_entry_exit_images") === "1");
	const [devices, setDevices] = useState([])
	const [totalDevicesAmount, setTotalDevicesAmount] = useState(null)
	const [serialNumberToFilter, setSerialNumberToFilter] = useState("All");
	const [deviceLoader, setDeviceLoader] = useState(false)
	const newSummary = false
	const [newSummaryData, setNewSummaryData] = useState(null)
	const summaryVehicleTypes = Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].label);
	const finalZones = currentParking.zones_obj ? JSON.parse(currentParking.zones_obj) : [];
	const [primaryParkingInfo, setPrimaryParkingInfo] = useState({})
	const [makeExitFree] = useState(sessionStorage.getItem("make_exit_free") === "1")
	const [paymentDistributions] = useState(sessionStorage.getItem("payment_distributions"));
	const [isSurveillanceExit, setIsSurveillanceExit] = useState(false);
	const [activeComponentEntered, setActiveComponentEntered] = useState(null);
	const [activeComponentExited, setActiveComponentExited] = useState(null);
	const [activeComponentAmounnt, setActiveComponentAmount] = useState(null);
	const [activeComponentPayment, setActiveComponentPayment] = useState(null);
	const [showTiles, setShowTiles] = useState(true)
	const [isAPIBreak, setIsAPIBreak] = useState(false)
	const [showEntryImageFilter, setShowEntryImageFilter] = useState(null);
	const [showExitImageFilter, setShowExitImageFilter] = useState(null);
	const abortVehicleSummaryRequest = useRef(null);
    const abortVehiclesRequest = useRef(null);
	// const [showRowFilters] = useState(true);
	const [focType, setFocType] = useState("")

	if (finalZones) {
		finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));
	}

	const onFocTypeChange = (e) =>{
		setFreeVehicleConfirmation({ ...freeVehicleConfirmation, remarks: e.target.value })
		setFocType(e.target.value)
	}

	const isInLastThreeMonthsLimit = () => {
		if (!lastThreeMonthsLimit) return true;

		const sD = moment(startDateTime)
		const eD = moment(endDateTime)
		const days = eD.diff(sD, 'days')

		return days < 90 || startDateTime == null || endDateTime == null ? true : false
	}

	const fetchVehicleSummary = () => {
		setIsAPIBreak(false)
		if (reduceSummary && startDateTime && endDateTime) {
			const sD = moment(startDateTime)
			const eD = moment(endDateTime)
			const days = eD.diff(sD, 'days')
			if (days > 31) return notify("You can only get data upto 10 days", "warning");
		}
		setLoadingVehicleSummary(true);
		let entryDeviceFilter = [];
		let exitDeviceFilter = [];
		let entryUserFilter = [];
		let exitUserFilter = [];
		
		if (entryPosDevice) entryDeviceFilter.push(...entryPosDevice);
		if (exitPosDevice) exitDeviceFilter.push(...exitPosDevice);
		
		if (entryUser) entryUserFilter.push(...entryUser);
		if (exitUser) exitUserFilter.push(...exitUser);

		var params = {
			access_key_id: currentParking.id,
			parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
			start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
			end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
			device_serial_number: serialNumberToFilter !== "All" ? serialNumberToFilter : null,
			category: categoryToFilter !== "All" ? categoryToFilter : "All",
			action: actionFilter ? actionFilter : '',
			vehicle_type: vehicleFilter ? vehicleFilter : null,
			payment_mode: paymentModeFilter ? JSON.stringify(paymentModeFilter) : undefined,
			last_three_months: lastThreeMonthsLimit,
			access_key: currentParking.access_key,
			show_surveillance_exit: isSurveillanceExit ? 1 : 0,
			entry_payment_mode: entryPaymentModes ? JSON.stringify(entryPaymentModes) : null,
			exit_payment_mode: exitPaymentModes ? JSON.stringify(exitPaymentModes) : null,
			entry_device_ids: JSON.stringify(entryDeviceFilter),
			exit_device_ids: JSON.stringify(exitDeviceFilter),
			entry_user_ids: JSON.stringify(entryUserFilter),
			exit_user_ids: JSON.stringify(exitUserFilter),
			is_commercial: commercialVehicles,
			fastag_status_at_entry: entryFastag ? JSON.stringify(entryFastag) : null,
			fastag_status_at_exit: exitFastag ? JSON.stringify(exitFastag) : null,
			duration: durationFilter,
			entry_image: showEntryImageFilter,
			exit_image: showExitImageFilter
		}

		if (abortVehicleSummaryRequest.current) abortVehicleSummaryRequest.current.abort()
        abortVehicleSummaryRequest.current = new AbortController();
		fetch(`${config.HOST_NAME}/crm/vehicleSummary?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
			},
			signal: abortVehicleSummaryRequest.current.signal,
		})
			.then(response => {
				saveTokens(response);
				return response.json();
			})
			.then(json => {
				if (json.success) {
					setVehicleSummary(json.data);
					// setShowPaymentTypeSummary(json.show_payment_type_summary)
					if (newSummary) formatSummaryData(json.data)
				} else {
					notify(json.message, "warning");
				}
				setLoadingVehicleSummary(false);
				setResetHeight((prev) => !prev)
			})
			.catch((e) => {
				if (e.name === "AbortError") console.log(e);
				else {
					setIsAPIBreak(true)
					setLoadingVehicleSummary(false);
					console.log(e)
				}
			})
	};

	const formatSummaryData = (data) => {
		const formattingData = [
			{
				title: 'Entered',
				value: data.enteredVehicles,
				valueFormatter: value => value,
				distributedLabels: Object.keys(data.vehicleTypes).map(type => data.vehicleTypes[type].label),
				distributedValues: Object.keys(data.vehicleTypes).map(type => data.vehicleTypes[type].entered),
				distributedIcons: Object.keys(data.vehicleTypes).map(type => vehicleSvgs[type]),
				distributionCount: vehicleTypesCount,
				isPaymentType: false
			},
			{
				title: 'Exited',
				value: data.exitedVehicles,
				valueFormatter: value => value,
				valueDescription: `(${data.exitedVehiclesCurrentPeriod} + ${data.exitedVehiclesPreviousPeriod})`,
				valueDescriptionTooltip: `Indicates No. of Vehicles Exited which were entered in the current time period + No. of Vehicles Exited which were entered before the current time period`,
				distributedLabels: Object.keys(data.vehicleTypes).map(type => data.vehicleTypes[type].label),
				distributedValues: Object.keys(data.vehicleTypes).map(type => data.vehicleTypes[type].exited),
				distributedIcons: Object.keys(data.vehicleTypes).map(type => vehicleSvgs[type]),
				distributedValueDescription: Object.keys(data.vehicleTypes).map(type => `(${data.vehicleTypes[type].exitedCurrentPeriod} + ${data.vehicleTypes[type].exitedPreviousPeriod})`),
				distributionCount: vehicleTypesCount,
				isPaymentType: true
			},
			{
				title: "Amount",
				value: data.amount,
				valueFormatter: value => `₹ ${value.toFixed(2)}`,
				valueDescription: `(${data.amountCurrentPeriod.toFixed(2)} + ${data.amountPreviousPeriod.toFixed(2)})`,
				valueDescriptionTooltip: `Indicates Collection from the vehicles which entered in the current time period + Collection from the vehicles which entered before the current time period`,
				distributedLabels: Object.keys(data.vehicleTypes).map(type => data.vehicleTypes[type].label),
				distributedValues: Object.keys(data.vehicleTypes).map(type => data.vehicleTypes[type].amount),
				distributedIcons: Object.keys(data.vehicleTypes).map(type => vehicleSvgs[type]),
				distributedValueDescription: Object.keys(data.vehicleTypes).map(type => `(${data.vehicleTypes[type].amountCurrentPeriod.toFixed(2)} + ${data.vehicleTypes[type].amountPreviousPeriod.toFixed(2)})`),
				distributionCount: vehicleTypesCount

			}
		]
		setNewSummaryData(formattingData)
	}

	const fetchVehicles = () => {
		setIsAPIBreak(false)
		if (reduceSummary && startDateTime && endDateTime) {
			const sD = moment(startDateTime)
			const eD = moment(endDateTime)
			const days = eD.diff(sD, 'days')
			if (days > 10) return notify("You can only get data upto 10 days", "warning");
		}
		setLoadingVehicles(true);
		let entryDeviceFilter = [];
		let exitDeviceFilter = [];
		let entryUserFilter = [];
		let exitUserFilter = [];
		
		if (entryPosDevice) entryDeviceFilter.push(...entryPosDevice);
		if (exitPosDevice) exitDeviceFilter.push(...exitPosDevice);
		
		if (entryUser) entryUserFilter.push(...entryUser);
		if (exitUser) exitUserFilter.push(...exitUser);

		var params = {
			access_key_id: currentParking.id,
			parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
			start_time: startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
			end_time: endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "",
			page: page,
			perPage: rowsPerPage,
			sortOrder: sortOrder,
			sortBy: sortBy,
			device_serial_number: serialNumberToFilter !== "All" ? serialNumberToFilter : null,
			search: JSON.stringify({ type: searchTypes, value: search }),
			category: categoryToFilter !== "All" ? categoryToFilter : "All",
			action: actionFilter ? actionFilter : '',
			vehicle_type: vehicleFilter ? vehicleFilter : null,
			payment_mode: paymentModeFilter ? JSON.stringify(paymentModeFilter) : undefined,
			last_three_months: lastThreeMonthsLimit,
			entry_payment_mode: entryPaymentModes ? JSON.stringify(entryPaymentModes) : null,
			exit_payment_mode: exitPaymentModes ? JSON.stringify(exitPaymentModes) : null,
			entry_device_ids: JSON.stringify(entryDeviceFilter),
			exit_device_ids: JSON.stringify(exitDeviceFilter),
			entry_user_ids: JSON.stringify(entryUserFilter),
			exit_user_ids: JSON.stringify(exitUserFilter),
			is_commercial: commercialVehicles,
			fastag_status_at_entry: entryFastag ? JSON.stringify(entryFastag) : null,
			fastag_status_at_exit: exitFastag ? JSON.stringify(exitFastag) : null,
			duration: durationFilter,
			entry_image: showEntryImageFilter,
			exit_image: showExitImageFilter
		}
		if (abortVehiclesRequest.current) abortVehiclesRequest.current.abort()
        abortVehiclesRequest.current = new AbortController();
		const url = isSurveillanceExit ? `${config.HOST_NAME}/crm/surveillanceExitedVehicles?${stringify(params)}` : `${config.HOST_NAME}/crm/vehicles?${stringify(params)}`;
		fetch(url, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
			},
			signal: abortVehiclesRequest.current.signal
		})
			.then(response => {
				saveTokens(response);
				return response.json();
			})
			.then(json => {
				if (json.success) {
					setVehicles(json.data);
					if (reduceSummary && json.totalLength > 25) {
						setTotalVehicleCount(25);
					} else {
						setTotalVehicleCount(json.totalLength);
					}
				} else {
					notify(json.message, "warning");
				}
				setLoadingVehicles(false);
				setResetHeight((prev) => !prev)
			})
			.catch((e) => {
				if (e.name === "AbortError") console.log(e)
				else {
					console.log(e);
					setIsAPIBreak(true)
					setLoadingVehicles(false);
				}
			})
	};

	const fetchDeviceSummary = () => {
		setDeviceLoader(true);
		var params = {
			access_key_id: currentParking.id,
			parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
			start_time: startDateTime ? moment(startDateTime).format('YYYY-MM-DD HH:mm:ss') : null,
			end_time: endDateTime ? moment(endDateTime).format('YYYY-MM-DD HH:mm:ss') : null,
			category: categoryToFilter !== "All" ? categoryToFilter : "All",
			action: actionFilter ? actionFilter : '',
			vehicle_type: vehicleFilter ? vehicleFilter : null,
			payment_mode: paymentModeFilter ? JSON.stringify(paymentModeFilter) : undefined,
			last_three_months: lastThreeMonthsLimit,
			access_key: currentParking.access_key,
			entry_payment_mode: entryPaymentModes ? entryPaymentModes : null,
			exit_payment_mode: exitPaymentModes ? exitPaymentModes : null,
		}

		fetch(`${config.HOST_NAME}/crm/getDeviceSummary?${stringify(params)}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`
			},
		})
			.then(response => {
				saveTokens(response);
				return response.json();
			})
			.then(json => {
				if (json.success) {
					setDevices(json.data);
					setTotalDevicesAmount(json.totalDevicesAmount)
				} else {
					notify(json.message, "warning");
				}
			})
			.catch((e) => {
				console.log(e);
				notify("Something went wrong", "warning");
			})
			.finally(() => {
				setDeviceLoader(false);
			});
	};

	const fetchSummary = () => {
		if (isInLastThreeMonthsLimit()) {
			fetchVehicleSummary();
			fetchVehicles();
		} else notify('You can only get data upto last 3 months.', 'warning')
	};

	const handleRequestSort = (property) => {
		const isAsc = sortBy === property && sortOrder === 'ASC';
		let tempOrder = isAsc ? 'DESC' : 'ASC';
		setSortOrder(tempOrder);
		setSortBy(property);
	};

	// const handleSelectAllClick = (event) => {
	// 	if (event.target.checked) {
	// 		const sR = {};
	// 		for (let v of vehicles) {
	// 			sR[v.id] = true;
	// 		}
	// 		setSelectedRows(sR);
	// 	} else {
	// 		setSelectedRows({});
	// 	}
	// };

	const EnhancedTableToolbarForMob = (props) => {
		if (selected.length === 0) {
			return null;
		}

		const selectedRow = vehicles.find(row => row.id === selected[0]);
		const freeVehicle = selectedRow && (selectedRow.free_vehicle === true || selectedRow.free_vehicle === 1 || selectedRow.free_vehicle === "1" || selectedRow.free_vehicle === "true");
		return (
			<Toolbar style={{ position: "sticky", top: 75, left: 0, width: "100%", padding: "2px 0", borderRadius: "12px 12px 12px 12px", backgroundColor: "#58ffaa", zIndex: 1 }}>
				<div style={{ padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
					<Typography sx={{ flex: '1 1 100%' }} color="inherit" variant="subtitle1" component="div">{selected.length} Selected</Typography>
					<div>
						<Button
							variant="text"
							startIcon={freeVehicle ? <AttachMoneyIcon /> : <MoneyOffIcon />}
							disabled={makeExitFree && selectedRow.exit_user_id !== "CLEARED" && selectedRow.exit_time ? false : selectedRow === undefined || (selectedRow.entry_time && selectedRow.exit_time && selectedRow.exit_user_id !== "CLEARED")}
							onClick={event => onFreeVehicleToggle(selectedRow.id, !freeVehicle, selectedRow.remarks, selectedRow.exit_user_id, selectedRow.license_number, selectedRow.entry_time, selectedRow.exit_time, selectedRow.mode_of_payment)}
						>
							{freeVehicle ? "Make Paid" : "Make Free"}
						</Button>
					</div>
				</div>
			</Toolbar>
		);
	};

	const isSelected = (id) => selected.indexOf(id) !== -1;

	const handleRowSelectMob = (event, name) => {
		const selectedIndex = selected.indexOf(name);
		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(selected, name);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(selected.slice(1));
		} else if (selectedIndex === selected.length - 1) {
			newSelected = newSelected.concat(selected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				selected.slice(0, selectedIndex),
				selected.slice(selectedIndex + 1),
			);
		}
		setSelected(newSelected);
	};

	// const handleRowSelect = (event, row) => {
	// 	if (event.target.checked) {
	// 		const sR = {
	// 			...selectedRows,
	// 			[row.id]: true
	// 		};
	// 		setSelectedRows(sR);
	// 	} else {
	// 		const sR = { ...selectedRows };
	// 		delete sR[row.id];
	// 		setSelectedRows(sR);
	// 	}
	// };

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const changePageWhileSearch = (newPage) => {
		setPage(newPage);
	}

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
		return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY ${use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`}`);
	};

	const renderDate = (datetime) => {
		const momentObj = moment(datetime, "YYYY-MM-DD HH:mm:ss");
		return momentObj.format("DD/MM/YYYY");
	};

	const renderTimeV2 = (datetime) => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
		const momentObj = moment(datetime, "YYYY-MM-DD HH:mm:ss");
		return momentObj.format(use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`);
	};

	const timeFormat = (type, time, timeComparison, style = false) => {
		let addSeconds = showTimeTillSeconds ? ":ss" : "";
		let format = use24HourFormat ? `HH:mm${addSeconds}` : `hh:mm${addSeconds} A`
		return type === "ENTRY" ? <div className={style ? "tableTimeFormatStyle" : ""}>
			<div className={moment(time).isBefore(moment(timeComparison)) ? 'errorColor fontWeightBold' : 'logsTableDataColor1 fontWeightBold'}>{moment(time).format(format)}</div>
			<div className={moment(time).isBefore(moment(timeComparison)) ? 'errorColor fontWeightMedium' : 'logsTableDataColor2 fontWeightMedium'}>{moment(time).format("DD/MM/YYYY")}</div>
		</div> :
			<div className={style ? "tableTimeFormatStyle" : ""}>
				<div className={moment(time).isAfter(moment(timeComparison)) ? 'errorColor fontWeightBold' : 'logsTableDataColor1 fontWeightBold'}>{moment(time).format(format)}</div>
				<div className={moment(time).isAfter(moment(timeComparison)) ? 'errorColor fontWeightMedium' : 'logsTableDataColor2 fontWeightMedium'}>{moment(time).format("DD/MM/YYYY")}</div>
			</div>
	}

	const onFreeVehicleToggle = (id, checked, remarks, exit_user_id, license_number, entry_time, exit_time, mode_of_payment) => {
		setFreeVehicleConfirmation({ id, free: checked, remarks: remarks, exit_user_id: exit_user_id, license_number: license_number, entry_time: entry_time, exit_time: exit_time, mode_of_payment: mode_of_payment });
	};

	const hideFreeVehicleConfirmation = event => {
		event.stopPropagation();
		setFreeVehicleConfirmation(null);
	};

	const toggleFreeVehicle = event => {
		event.stopPropagation();
		if (typeof freeVehicleConfirmation.remarks !== "string" || !new RegExp("[A-z]+").test(freeVehicleConfirmation.remarks)) {
			return notify("Please add remarks", "warning");
		}

		if (makeExitFree && freeVehicleConfirmation.exit_time !== '' && freeVehicleConfirmation.exit_time !== null && freeVehicleConfirmation.mode_of_payment && freeVehicleConfirmation.mode_of_payment !== 'CASH') {
			return notify(`FOC not allowed for Vehicle with ${freeVehicleConfirmation.mode_of_payment}`, "warning");
		}


		setFreeVehicleConfirmation({ ...freeVehicleConfirmation, loading: true });
		var params = {
			user_id: sessionStorage.getItem("user_id"),
			free_vehicle: freeVehicleConfirmation.free,
			remarks: freeVehicleConfirmation.remarks,
			exit_user_id: freeVehicleConfirmation.exit_user_id,
			access_key: currentParking.access_key,
			entry_time: freeVehicleConfirmation.entry_time,
			license_number: freeVehicleConfirmation.license_number,
			mode_of_payment_at_entry: freeVehicleConfirmation.mode_of_payment_at_entry,
			amount_at_entry: freeVehicleConfirmation.amount_at_entry,
			exit_time: freeVehicleConfirmation.exit_time,
			make_paid_amount: !freeVehicleConfirmation.free ? freeVehicleConfirmation.make_paid_amount : 0,
			mode_of_payment: freeVehicleConfirmation.mode_of_payment ? freeVehicleConfirmation.mode_of_payment : ''
		}
		const url = makeExitFree && freeVehicleConfirmation.exit_user_id !== 'CLEARED' && freeVehicleConfirmation.exit_time && freeVehicleConfirmation.exit_time !== '' && freeVehicleConfirmation.exit_time != null ? `${config.HOST_NAME}/crm/v3/pastVehicles/${freeVehicleConfirmation.id}/freeVehicle` : `${config.HOST_NAME}/crm/v3/currentVehicles/${freeVehicleConfirmation.id}/freeVehicle`
		fetch(url, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
			},
			body: JSON.stringify(params)
		})
			.then(response => {
				saveTokens(response)
				return response.json()
			})
			.then(json => {
				setFreeVehicleConfirmation({ ...freeVehicleConfirmation, loading: false });
				if (json.success) {
					hideFreeVehicleConfirmation(event);
					fetchSummary();
					notify("Record Updated", "success");
				} else {
					notify(json.message, 'warning');
				}
			})
			.catch(error => {
				console.log(error);
				setFreeVehicleConfirmation({ ...freeVehicleConfirmation, loading: false });
				notify('Error updating record', 'warning');
			});
	};

	const VehicleMakeFreeOrPaid = ({ data: selectedRow }) => {
		const freeVehicle = selectedRow && (selectedRow.free_vehicle === true || selectedRow.free_vehicle === 1 || selectedRow.free_vehicle === "1" || selectedRow.free_vehicle === "true");
		return (
			<div title="Make Free">
				<RaButton
					disabled={makeExitFree && selectedRow.exit_user_id !== "CLEARED" && selectedRow.exit_time ? false : selectedRow === undefined || (selectedRow.entry_time && selectedRow.exit_time && selectedRow.exit_user_id !== "CLEARED")}
					onClick={event => onFreeVehicleToggle(selectedRow.id, !freeVehicle, selectedRow.remarks, selectedRow.exit_user_id, selectedRow.license_number, selectedRow.entry_time, selectedRow.exit_time, selectedRow.mode_of_payment)}
				>
					{freeVehicle ? <AttachMoneyIcon /> : <MoneyOffIcon />}
				</RaButton>
			</div>
		);
	};

	const onParkingChange = (parking) => {
		setCurrentParking({ ...parking, allZones: true });
	};

	const onZoneChange = (event) => {
		if (event.target.value === "All") {
			setCurrentParking({ ...primaryParkingInfo });
		} else {
			const result = finalZones.find((val) => val.id === event.target.value)
			setCurrentParking({
				...currentParking,
				id: event.target.value,
				name: result && result.name ? result.name : undefined,
				access_key: result && result.access_key ? result.access_key : undefined,
				allZones: event.target.value === "All"
			});
		}

	};

	const TableRowsLoader = ({ rowsNum }) => {
		return [...Array(rowsNum)].map((row, index) => (
			<TableRow key={index}>
				<StyledTableCell padding="checkbox"><Checkbox color="primary" checked={false} /></StyledTableCell>
				{Object.keys(displayColumns).map(column =>
					(displayColumns[column] && <StyledTableCell component="th" scope="row"><Skeleton variant="text" height={36} width={100} /></StyledTableCell>))}
			</TableRow>
		));
	};

	useEffect(() => {
		if (showSeparateEntryExitImages) {
			delete SUMMARY_COLUMNS["Vehicle Image"];
			delete SUMMARY_COLUMNS["Images"];
		} else {
			delete SUMMARY_COLUMNS["Entry Image"];
			delete SUMMARY_COLUMNS["Exit Image"];
		}

		const displayColumnsKeys = Object.keys(displayColumns);
		const summaryColumnsKeys = Object.keys(SUMMARY_COLUMNS);

		const isOutdated = displayColumnsKeys.length !== summaryColumnsKeys.length || summaryColumnsKeys.some((key) => !displayColumnsKeys.includes(key));
		if (isOutdated) {
			const temp = { ...SUMMARY_COLUMNS };
			for (let column in SUMMARY_COLUMNS) {
				if (displayColumns[column] === false)
					temp[column] = false;
			}
			setDisplayColumns(temp);
			localStorage.setItem("summaryColumns", JSON.stringify(temp));
		} else {
			localStorage.setItem("summaryColumns", JSON.stringify(displayColumns));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [displayColumns]);

	useEffect(() => {
		if (record.features) {
			setShowDayPassColumn(record.features.parking_cost.normal_daily_pricing.day_pass && record.features.parking_cost.normal_daily_pricing.day_pass.enabled);
			setVehicleTypesCount(getVehicleTypeCount(record.features));
			setVehicleTypes(record.features.vehicle_type);
		}
	}, [record]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (record && isInLastThreeMonthsLimit()) {
			if (!reduceSummary || !(search && search.length > 0 && search.length < 4)) fetchVehicles();
		}
		else notify('You can only get data upto last 3 months.', 'warning')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [record, currentParking, page, rowsPerPage, sortOrder, startDateTime, endDateTime, serialNumberToFilter, categoryToFilter, actionFilter, paymentModeFilter, search, searchTypes, isSurveillanceExit, entryPaymentModes, exitPaymentModes, entryUser, exitUser, entryPosDevice, exitPosDevice, commercialVehicles, entryFastag, exitFastag, durationFilter, showEntryImageFilter, showExitImageFilter, filterListValue]);

	useEffect(() => {
		if (record && isInLastThreeMonthsLimit()) {
			fetchVehicleSummary()
			if (!reduceSummary && currentParking.separate_summary_of_devices === 1) fetchDeviceSummary();
		} else notify('You can only get data upto last 3 months.', 'warning')
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [record, currentParking, categoryToFilter, actionFilter, startDateTime, endDateTime, paymentModeFilter, isSurveillanceExit, entryPaymentModes, exitPaymentModes, entryUser, exitUser, entryPosDevice, exitPosDevice, commercialVehicles, entryFastag, exitFastag, durationFilter, showEntryImageFilter, showExitImageFilter, filterListValue]);

	useEffect(() => {
		for (let val in filterListValue) {
			if (filterListValue[val].filterType === "Actions") {
				setActionFilter(filterListValue[val].value ? filterListValue[val].value : undefined);
			} else if (filterListValue[val].filterType === "Category") {
				if (filterListValue[val].value) {
					if (filterListValue[val].value === "DROP OFF") {
						setCategoryToFilter("IDF");
					} else {
						setCategoryToFilter(filterListValue[val].value);
					}
				} else {
					setCategoryToFilter(undefined);
				}
			} else if (filterListValue[val].filterType === "Payment Mode") {
				setPaymentModeFilter(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Vehicle Type") {
				setVehicleFilter(filterListValue[val].id);
			}
			else if (filterListValue[val].filterType === "Entry Mode") {
				if (Array.isArray(filterListValue[val].value)) setEntryPaymentModes(filterListValue[val].value.map((val) => val === "POS" ? "CASH" : val));
				else setEntryPaymentModes(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Exit Mode") {
				if (Array.isArray(filterListValue[val].value)) setExitPaymentModes(filterListValue[val].value.map((val) => val === "POS" ? "CASH" : val));
				else setExitPaymentModes(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Entry Gate") {
				setEntryUser(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Exit Gate") {
				setExitUser(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Entry POS") {
				setEntryPosDevice(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Exit POS") {
				setExitPosDevice(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Commercial Vehicle") {
				setCommercialVehicles(filterListValue[val].id);
			}
			else if (filterListValue[val].filterType === "Entry FASTag Status") {
				setEntryFastag(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Exit FASTag Status") {
				setExitFastag(filterListValue[val].value);
			}
			else if (filterListValue[val].filterType === "Duration") {
				setDurationFilter(filterListValue[val].value);
			} 
			else if (filterListValue[val].filterType === "Entry Image") {
				setShowEntryImageFilter(filterListValue[val].value ? filterListValue[val].value === 'Captured' ? true : filterListValue[val].value === 'Not Captured' ? false : null : null);
			}
			else if (filterListValue[val].filterType === "Exit Image") {
				setShowExitImageFilter(filterListValue[val].value ? filterListValue[val].value === 'Captured' ? true : filterListValue[val].value === 'Not Captured' ? false : null : null);
			}
		}
	}, [filterListValue]); // eslint-disable-next-line react-hooks/exhaustive-deps

	useEffect(() => {
		setPrimaryParkingInfo({ ...currentParking })
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		fetchVehicleSummary();
		fetchVehicles();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vehicleFilter])

	const filterTypesInitState = [
		{
			filterType: "Actions",
			dataList: [{ name: "ENTERED", id: 1 }, { name: "EXITED", id: 2 }, { name: "NOT EXITED", id: 3 }, {name: 'AUTO-EXITED', id: 4}],
			listType: "Static",
			caseType: "Static",
			showFilter: true
		},
		{
			filterType: "Category",
			dataList: [{ name: "PAID", id: 1 }, { name: "DROP OFF", id: 2 }, { name: "FOC", id: 3 }, { name: "UNPAID", id: 4 }, { name: "DIGITAL PAYMENTS", id: 5 }, { name: "PASS", id: 5 }, { name: "DROP-OFF PRIVATE", id: 6 }, { name: "DROP-OFF MANUAL", id: 7 }, { name: "DROP-OFF COMMERCIAL", id: 8 },],
			listType: "Static",
			caseType: "Static",
			showFilter: currentParking && currentParking.category_filter === 1 && (defaultCategoryFilter == null || defaultCategoryFilter === "" || defaultCategoryFilter === "null"),
		},
		{
			filterType: "Vehicle Type",
			dataList: [{ name: "Bike", id: 2 }, { name: "Auto Rickshaw", id: 3 }, { name: "Car", id: 4 }, { name: "Cycle", id: 5 }, { name: "Bus", id: 6 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true
		},
		{
			filterType: "Payment Mode",
			dataList: [{ name: "Cash", id: 1 }, { name: "Card", id: 2 }, { name: "POS UPI", id: 3 }, { name: "Online Static QR", id: 4 },  { name: "FASTag", id: 5 }, { name: "Wallet", id: 6 }, { name: "Multiple Payment", id: 7 }],
			listType: "Static",
			caseType: "Static",
			showFilter: currentParking.show_amount_in_crm === 1,
			filterFormat: "Checkbox"
		},
		{
			filterType: "Display Columns",
			dataList: [],
			listType: "CheckboxStatic",
			caseType: "CheckboxTypeStatic",
			showFilter: true,
			filterFormat: "Checkbox"
		},
		{
			filterType: "Entry Mode",
			dataList: [{ name: "FASTag", id: 1 }, { name: "POS", id: 2 }, { name: "ANPR", id: 3 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true,
			filterFormat: "Checkbox"
		},
		{
			filterType: "Exit Mode",
			dataList: [{ name: "FASTag", id: 1 }, { name: "POS", id: 2 }, { name: "ANPR", id: 3 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true,
			filterFormat: "Checkbox"
		},
		{
			resourcePath: "parkingDevices",
			filterType: "Entry Gate",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON-ENTRY"
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox",
			showSearchBar: true
		},
		{
			resourcePath: "parkingDevices",
			filterType: "Exit Gate",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "CON-EXIT",
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox",
			showSearchBar: true
		},
		{
			resourcePath: "parkingDevices",
			filterType: "Entry POS",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "POS-ENTRY",
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox",
			showSearchBar: true
		},
		{
			resourcePath: "parkingDevices",
			filterType: "Exit POS",
			filterParams: {
				access_key_id: currentParking.id,
				parking_info_id: currentParking.allZones ? currentParking.parking_info_id : null,
				sub_type: "POS-EXIT",
			},
			dataList: [],
			searchList: [],
			listType: "Dynamic",
			resourceParam: "name",
			source: "name",
			showFilter: true,
			filterFormat: "Checkbox",
			showSearchBar: true
		},
		{
			filterType: "Commercial Vehicle",
			dataList: [{ name: "Commercial", id: 1 }, { name: "Non-commercial", id: 0 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true,
		},
		{
			filterType: "Entry FASTag Status",
			dataList: [{ name: "ACTIVE", id: 1 }, { name: "HOTLIST", id: 2 }, { name: "EXEMPT", id: 3 }, { name: "LOW BALANCE", id: 4 }, { name: "INVALID CARRIAGE", id: 5 }, { name: "BLACKLIST", id: 6 }, { name: "CLOSED", id: 6 }],
			listType: "Static",
			caseType: "Static",
			filterFormat: "Checkbox",
			showFilter: true,
		},
		{
			filterType: "Exit FASTag Status",
			dataList: [{ name: "ACTIVE", id: 1 }, { name: "HOTLIST", id: 2 }, { name: "EXEMPT", id: 3 }, { name: "LOW BALANCE", id: 4 }, { name: "INVALID CARRIAGE", id: 5 }, { name: "BLACKLIST", id: 6 }, { name: "CLOSED", id: 6 }],
			listType: "Static",
			caseType: "Static",
			filterFormat: "Checkbox",
			showFilter: true,
		},
		{
			filterType: "Entry Image",
			dataList: [{ name: "Captured", id: 1 }, { name: "Not Captured", id: 2 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true,
		},
		{
			filterType: "Exit Image",
			dataList: [{ name: "Captured", id: 1 }, { name: "Not Captured", id: 2 }],
			listType: "Static",
			caseType: "Static",
			showFilter: true,
		},
		{
			filterType: "Duration",
			dataList: [],
			listType: "Static",
			caseType: "Static",
			filterFormat: "Text",
			showFilter: true,
		},
	];

	const fomattingFilter = (filterList) => {
		const result = {};
		if (filterList) {
			for (const obj of filterList) {
				const { filterType, value, id } = obj;
				if (value && id) result[filterType.replaceAll(" ", "_").toLowerCase()] = { value, id };
			}
		}
		return result;
	}
	const reportParams = {
		access_key_ids: currentParking.allZones ? finalZones.map((zone) => zone.id) : [currentParking.id],
		report_name: "VEHICLE_SUMMARY",
		report_format: "xlsx",
		start_time: moment(startDateTime ? startDateTime : moment(new Date()).startOf('day')).format("YYYY-MM-DD HH:mm:ss"),
		end_time: moment(endDateTime ? endDateTime : moment(new Date()).endOf('day')).format("YYYY-MM-DD HH:mm:ss"),
		filters: filterListValue ? fomattingFilter(filterListValue) : undefined,
	};

	const handlePaymentTiles = () => {
		setShowPaymentTypeSummary((prevValue) => !prevValue);
		setShowTilesForExited(false);
		setShowTilesForEntered(false);
		setActiveComponentPayment(prevValue => prevValue ? null : 'Payment Summary');
		setActiveComponentAmount(null);
		setActiveComponentEntered(null);
		setActiveComponentExited(null);
	}
	const handlePaidAmountTiles = () => {
		setShowPaymentTypeSummary((prevValue) => !prevValue);
		setShowTilesForExited(false);
		setShowTilesForEntered(false);
		setActiveComponentAmount(prevValue => prevValue ? null : 'Amount');
		setActiveComponentPayment(null);
		setActiveComponentEntered(null);
		setActiveComponentExited(null);
	}
	const handleEnteredTiles = () => {
		setShowPaymentTypeSummary(false);
		setShowTilesForExited(false);
		setShowTilesForEntered((prevValue) => !prevValue);
		setActiveComponentEntered(prevValue => prevValue ? null : 'Entered');
		setActiveComponentPayment(null);
		setActiveComponentAmount(null);
		setActiveComponentExited(null);
	};
	const handleExitedTiles = () => {
		setShowPaymentTypeSummary(false);
		setShowTilesForExited((prevValue) => !prevValue);
		setShowTilesForEntered(false);
		setActiveComponentExited(prevValue => prevValue ? null : 'Exited');
		setActiveComponentPayment(null);
		setActiveComponentAmount(null);
		setActiveComponentEntered(null);
	}
	const handleClick = () => {
		console.info('You clicked the Chip.');
	};

	const handleDelete = () => {
		console.info('You clicked the delete icon.');
	};
	const nonEmptyValues = filterListValue ? filterListValue.filter(entry => entry.value !== '') : null;

	const downloadReportHandler = async () => {
		let reportStatus = await generateReport(reportParams)
		if (reportStatus.success) navigate.push("/reports")
		else notify(reportStatus.message, "warning")
	}

	useEffect(() => {
		if (search !== "") setShowTiles(false)
		else setShowTiles(true)
	}, [search])

	const renderPaymentModeChip = (paymentMode, note = "") => {
		let paymentModeColor = paymentMode
		let paymentModeText = paymentMode
		const multiplePaymentModeName = "FASTag + CASH"
		if (note === "Multiple exit" && paymentMode === "FASTag") {
			paymentModeColor = multiplePaymentModeName
			paymentModeText = multiplePaymentModeName
		} else if (paymentMode === "ONLINE") paymentModeText = 'ONLINE (Static QR)'

		return (
			<div className="fontWeightBold" style={paymentModeColors[paymentModeColor] ? { color: paymentModeColors[paymentModeColor], backgroundColor: (paymentModeColors[paymentModeColor] + "19"), fontSize: 10, borderRadius: 2, padding: "2px 4px" } : { color: "#555555", backgroundColor: "#55555519", fontSize: 10, borderRadius: 2 }}>
				{paymentModeText === multiplePaymentModeName && <ErrorOutlineIcon style={{fontSize: "10px"}}/>} {paymentModeText}
			</div>
		)
	}


	return (
		<div>
			<div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
				{showFilter &&
					<ParkingSearchSelector
						value={currentParking}

						onChange={onParkingChange}
						clearable={false}
						pathName={location.pathname}
					/>
				}
				{currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
					<FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
						<InputLabel>Zone Name</InputLabel>
						<Select
							value={currentParking.allZones ? "All" : currentParking.id}
							onChange={onZoneChange}
							label="Zone Name"
							variant="outlined"
						>
							<MenuItem value="All">All</MenuItem>
							{finalZones.map((zone, index) => (
								<MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
							))}
						</Select>
					</FormControl>
				}
			</div>

			<div className='customStyleForDataSearchDiv'>
				{sessionStorage.getItem("hide_summary_search") !== "1" && <CustomSearch changePageWhileSearch={changePageWhileSearch} search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={SEARCH_TYPES} pathName={location.pathname} vehicleSummary />}
				<CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} showOnlyCustomPicker={reduceSummary} />
				{!reduceSummary && <CustomFilter
					filterTypesInitState={filterTypesInitState}
					filterListValue={filterListValue}
					setFilterListValue={setFilterListValue}
					defaultColumns={SUMMARY_COLUMNS}
					displayColumns={displayColumns}
					setDisplayColumns={setDisplayColumns}
					storageKey="summaryColumns"
				/>}
				{sessionStorage.getItem('check_vehicle_exit') === "1" && <Button className={isSurveillanceExit ? 'buttonStyle addBorderRadius primaryBgColorLight primaryColor' : 'buttonStyle addBorderRadius'} title='Violations' variant='contained' color="secondary" disableElevation size="small"
					onClick={() => {
						setIsSurveillanceExit((prev => !prev))
					}}>
					{isSurveillanceExit ? <VideocamIcon style={{ fontSize: "20px" }} /> : <VideocamOffIcon />}
				</Button>}
				{(sessionStorage.getItem("show_reports") === "1" || sessionStorage.getItem("role") === "admin") &&
					<Button
						className='buttonStyle addBorderRadius'
						variant="contained"
						color="secondary"
						disableElevation
						size="small"
						onClick={(event) => downloadReportHandler()}
					>
						<GetAppIcon />
					</Button>
				}
				<AutoRefreshToggle storageKey='auto_refresh_vehicle_summary' onInterval={fetchSummary} />
			</div>
			{!reduceSummary && <CustomRowFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} defaultColumns={SUMMARY_COLUMNS} />}

			{/* {nonEmptyValues && nonEmptyValues[0] && <div className='rowFilterScroll' style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: 10, marginTop: 10 }}>
				<Stack direction="row" spacing={1}>
					{nonEmptyValues && nonEmptyValues.map((entry, index) => {
						if ((Array.isArray(entry.value) && entry.value.length > 0) || (typeof entry.value === 'string' && entry.value.trim() !== "")) {
							return (
								<Chip
									key={index}
									label={`${entry.filterType}: ${Array.isArray(entry.value) ? entry.value.join(', ') : entry.value}`}
									onClick={handleClick}
								/>
							)
						} else {
							return null;
						}
					})}
				</Stack>
			</div>} */}
			<ShowTimePeriod startDateTimeFilter={startDateTime} endDateTimeFilter={endDateTime} showTiles={isAPIBreak ? !isAPIBreak : showTiles} setShowTiles={setShowTiles} style={{ marginBottom: 10 }} />
			{isAPIBreak ? <Paper style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px 18px 20px", marginTop: 10 }}>
			<InfoOutlinedIcon style={{ fontSize: 16, color: "#888", marginRight: 10 }} />
				<div style={{ color: "#334D6E", fontSize: 13, fontFamily: "Poppins-SemiBold" }}>Something wasn't right. Try refreshing the page, please.</div>
			</Paper>
				:
				<>
					{newSummary && newSummaryData && !loadingVehicleSummary &&
						<NewSummaryCard
							data={newSummaryData}
							loading={loadingVehicleSummary}
						/>}
					{showTiles &&
						<div className="vehicleSummaryFlexContainer" style={{ marginTop: 15 }}>
							{!isSurveillanceExit &&
								<VehicleSummaryCard
									title="Entered"
									value={vehicleSummaryMaskHandler(vehicleSummary.enteredVehicles)}
									VehiclesVisitor={vehicleSummaryMaskHandler(vehicleSummary.enteredVehiclesVisitor)}
									VehiclesPass={vehicleSummaryMaskHandler(vehicleSummary.enteredVehiclesPass)}
									distributedLabels={summaryVehicleTypes}
									distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].entered))}
									distributedValuesVisitor={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].enteredVisitor))}
									distributedValuesPass={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].enteredPass))}
									distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
									distributionCount={vehicleTypesCount}
									loading={loadingVehicleSummary}
									details={currentParking.show_pass_in_vehicle_summary}
									handleTilesClick={handleEnteredTiles}
									// isActive={activeComponentEntered === 'Entered'}
									isActive={currentParking.show_pass_in_vehicle_summary && activeComponentEntered === 'Entered'}
									style={{ flex: 1 }}
								/>}
							{!isSurveillanceExit &&
								<VehicleSummaryCard
									title="Exited"
									value={vehicleSummaryMaskHandler(vehicleSummary.exitedVehicles, "Count")}
									VehiclesVisitor={vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesVisitor)}
									VehiclesPass={vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesPass)}
									valueDescription={`(${vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesCurrentPeriod)} + ${vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesPreviousPeriod)})`}
									valueDescriptionVisitor={`(${vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesCurrentPeriodVisitor)} + ${vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesPreviousPeriodVisitor)})`}
									valueDescriptionPass={`(${vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesCurrentPeriodPass)} + ${vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesPreviousPeriodPass)})`}
									valueDescriptionTooltip={`Indicates No. of Vehicles Exited which were entered in the current time period + No. of Vehicles Exited which were entered before the current time period`}
									distributedLabels={summaryVehicleTypes}
									distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exited))}
									distributedValuesVisitor={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedVisitor))}
									distributedValuesPass={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedPass))}
									distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
									distributedValueDescription={Object.keys(vehicleSummary.vehicleTypes).map(type => `(${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedCurrentPeriod)} + ${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedPreviousPeriod)})`)}
									distributedValueDescriptionVisitor={Object.keys(vehicleSummary.vehicleTypes).map(type => `(${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedCurrentPeriodVisitor.toFixed(2))} + ${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedPreviousPeriodVisitor.toFixed(2))})`)}
									distributedValueDescriptionPass={Object.keys(vehicleSummary.vehicleTypes).map(type => `(${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedCurrentPeriodPass.toFixed(2))} + ${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedPreviousPeriodPass.toFixed(2))})`)}
									distributionCount={vehicleTypesCount}
									loading={loadingVehicleSummary}
									details={currentParking.show_pass_in_vehicle_summary}
									handleTilesClick={handleExitedTiles}
									isActive={currentParking.show_pass_in_vehicle_summary && activeComponentExited === 'Exited'}
									style={{ flex: 1 }}
								/>
							}
							{!isSurveillanceExit && currentParking.show_foc_summary !== 1 && currentParking.show_amount_in_crm === 1 && !showPaidUnpaidAmount && paymentDistributions === 'P' &&
								<VehicleSummaryCard
									title="Amount"
									value={vehicleSummaryMaskHandler(+vehicleSummary.amount.toFixed(2), "Amount")}
									valueFormatter={value => `₹ ${value}`}
									valueDescription={`(₹${vehicleSummaryMaskHandler(+vehicleSummary.amountCurrentPeriod.toFixed(2), "Amount")} + ₹${vehicleSummaryMaskHandler(+vehicleSummary.amountPreviousPeriod.toFixed(2), "Amount")})`}
									valueDescriptionTooltip={`Indicates Collection from the vehicles which entered in the current time period + Collection from the vehicles which entered before the current time period`}
									distributedLabels={summaryVehicleTypes}
									distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(+vehicleSummary.vehicleTypes[type].amount.toFixed(2), "Amount"))}
									distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
									distributedValueDescription={Object.keys(vehicleSummary.vehicleTypes).map(type => `(₹${vehicleSummaryMaskHandler(+vehicleSummary.vehicleTypes[type].amountCurrentPeriod.toFixed(2), "Amount")} + ₹${vehicleSummaryMaskHandler(+vehicleSummary.vehicleTypes[type].amountPreviousPeriod.toFixed(2), "Amount")})`)}
									distributionCount={vehicleTypesCount}
									loading={loadingVehicleSummary}
									details={currentParking.show_payment_type_summary}
									handleTilesClick={handlePaidAmountTiles}
									isActive={currentParking.show_payment_type_summary && activeComponentAmounnt === 'Amount'}
									style={{ flex: 1 }}
								/>}
							{currentParking.show_foc_summary !== 1 && currentParking.show_amount_in_crm === 1 && showPaidUnpaidAmount && paymentDistributions === 'P' &&
								<>
									<VehicleSummaryCard
										title="Paid Amount"
										value={vehicleSummaryMaskHandler(+vehicleSummary.amount.toFixed(2))}
										valueFormatter={value => `₹ ${value}`}
										valueDescription={`(${vehicleSummaryMaskHandler(+vehicleSummary.amountCurrentPeriod.toFixed(2), "Amount")} + ${vehicleSummaryMaskHandler(+vehicleSummary.amountPreviousPeriod.toFixed(2), "Amount")})`}
										valueDescriptionTooltip={`Indicates Collection from the vehicles which entered in the current time period + Collection from the vehicles which entered before the current time period`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].amount))}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributedValueDescription={Object.keys(vehicleSummary.vehicleTypes).map(type => `(${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].amountCurrentPeriod)} + ${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].amountPreviousPeriod)})`)}
										distributionCount={vehicleTypesCount}
										style={{ flex: 1 }}
									/>
									<VehicleSummaryCard
										title="Unpaid Amount"
										value={vehicleSummary && vehicleSummary.unpaidAmount ? `₹ ${vehicleSummaryMaskHandler(vehicleSummary.unpaidAmount.toFixed(2), "Amount")}` : `₹ 0.00`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => `₹ ${vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].unpaid_amount)}`)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										style={{ flex: 1 }}
									/>
								</>
							}
							{currentParking.show_amount_in_crm === 1 && (paymentDistributions === 'PM' || paymentDistributions === 'MP' || paymentDistributions === 'PMP' || paymentDistributions === 'PP') &&
								<VehicleSummaryCard
									title="Payment Summary"
									paymentDistributionsData={vehicleSummary}
									loading={loadingVehicleSummary}
									handlePaymentTiles={handlePaymentTiles}
									isActive={activeComponentPayment === 'Payment Summary'}
									style={{ flex: 1 }}
								/>}
							{/*<Link to={`/currentlyParked?${queryString.stringify({ parking: JSON.stringify(currentParking) })}`} style={{ textDecoration: "none" }}>*/}

							{!isSurveillanceExit && <VehicleSummaryCard
								title="Not Exited"
								value={vehicleSummaryMaskHandler(vehicleSummary.notExited)}
								distributedLabels={summaryVehicleTypes}
								distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].notExited))}
								distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
								distributionCount={vehicleTypesCount}
								loading={loadingVehicleSummary}
								details={false}
								style={{ flex: 1 }}
							/>}

							{currentParking.show_violation_details === 1 &&
								<VehicleSummaryCard
									title="Violation"
									value={vehicleSummaryMaskHandler(vehicleSummary.violationCount)}
									distributedLabels={summaryVehicleTypes}
									distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].violation_entered))}
									distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
									distributionCount={vehicleTypesCount}
									loading={loadingVehicleSummary}
									style={{ flex: 1 }}
								/>
							}
							{isSurveillanceExit && vehicleSummary && vehicleSummary.surveillanceVehiclesExitCount != null ?
								<VehicleSummaryCard
									title="Violations"
									value={vehicleSummaryMaskHandler(vehicleSummary.surveillanceVehiclesExitCount)}
									distributedLabels={summaryVehicleTypes}
									distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].surveillance_vehicles_exited))}
									distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
									distributionCount={vehicleTypesCount}
									loading={loadingVehicleSummary}
									style={{ flex: 1 }}
								/>
								: null}

							{!reduceSummary && currentParking.separate_summary_of_devices === 1 &&
								<DevicesUnderParking devices={devices} totalDevicesAmount={totalDevicesAmount} serialNumberToFilter={serialNumberToFilter} setSerialNumberToFilter={setSerialNumberToFilter} loading={deviceLoader} />
							}
						</div>
					}

					{showTiles &&
						<div className='vehicleSummaryCardScroll'>
							<div className='vehicleSummaryCardFlexScroll'>
								{!!currentParking.show_payment_type_summary && showPaymentTypeSummary && <>
									<VehicleSummaryCard
										title="Cash"
										showTileOnZeroAmount={vehicleSummary.cashAmount > 0 ? true : false}
										value={vehicleSummaryMaskHandler(vehicleSummary.cashAmount ? +vehicleSummary.cashAmount.toFixed(2) : 0, "Amount")}
										valueFormatter={value => `₹ ${value}`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].cash_amount)}
										distributedCount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].cash_entered)}
										distributedAmount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].cash_amount)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										vehicleCount={vehicleSummaryMaskHandler(vehicleSummary.cashCount)}
										loading={loadingVehicleSummary}
										isPaymentType={true}
										style={{ minWidth: 250 }}
									/>
									<VehicleSummaryCard
										title="Card"
										showTileOnZeroAmount={vehicleSummary.cardAmount > 0 ? true : false}
										value={vehicleSummaryMaskHandler(vehicleSummary.cardAmount ? +vehicleSummary.cardAmount.toFixed(2) : 0)}
										valueFormatter={value => `₹ ${value}`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].card_amount)}
										distributedCount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].card_entered)}
										distributedAmount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].card_amount)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										vehicleCount={vehicleSummaryMaskHandler(vehicleSummary.cardCount)}
										loading={loadingVehicleSummary}
										isPaymentType={true}
										style={{ minWidth: 250 }}
									/>
									<VehicleSummaryCard
										title="POS UPI"
										showTileOnZeroAmount={vehicleSummary.upiAmount > 0 ? true : false}
										value={vehicleSummaryMaskHandler(vehicleSummary.upiAmount ? +vehicleSummary.upiAmount : 0)}
										valueFormatter={value => `₹ ${value}`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].upi_amount)}
										distributedCount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].upi_entered)}
										distributedAmount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].upi_amount)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										vehicleCount={vehicleSummaryMaskHandler(vehicleSummary.upiCount)}
										loading={loadingVehicleSummary}
										isPaymentType={true}
										style={{ minWidth: 250 }}
									/>
									<VehicleSummaryCard
										title="Online Static QR"
										showTileOnZeroAmount={vehicleSummary.onlineAmount > 0 ? true : false}
										value={vehicleSummaryMaskHandler(vehicleSummary.onlineAmount ? +vehicleSummary.onlineAmount : 0)}
										valueFormatter={value => `₹ ${value}`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].online_amount)}
										distributedCount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].online_entered)}
										distributedAmount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].online_amount)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										vehicleCount={vehicleSummaryMaskHandler(vehicleSummary.onlineCount)}
										loading={loadingVehicleSummary}
										isPaymentType={true}
										style={{ minWidth: 250 }}
									/>
									{!!currentParking.show_payment_type_summary && !showFastagPayment && <VehicleSummaryCard
										title="Wallet"
										showTileOnZeroAmount={vehicleSummary.walletAmount > 0 ? true : false}
										value={vehicleSummaryMaskHandler(vehicleSummary.walletAmount ? +vehicleSummary.walletAmount.toFixed(2) : 0)}
										valueFormatter={value => `₹ ${value}`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].wallet_amount)}
										distributedCount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].wallet_entered)}
										distributedAmount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].wallet_amount)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										vehicleCount={vehicleSummaryMaskHandler(vehicleSummary.walletCount)}
										loading={loadingVehicleSummary}
										isPaymentType={true}
										style={{ minWidth: 250 }}
									/>}
									{!!currentParking.show_payment_type_summary && !!showFastagPayment && <VehicleSummaryCard
										title="Fastag"
										showTileOnZeroAmount={vehicleSummary.fastagAmount > 0 ? true : false}
										value={vehicleSummaryMaskHandler(vehicleSummary.fastagAmount ? +vehicleSummary.fastagAmount.toFixed(2) : 0)}
										valueFormatter={value => `₹ ${value}`}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].fastag_amount)}
										distributedCount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].fastag_entered)}
										distributedAmount={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummary.vehicleTypes[type].fastag_amount)}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										vehicleCount={vehicleSummaryMaskHandler(vehicleSummary.fastagCount)}
										loading={loadingVehicleSummary}
										isPaymentType={true}
										style={{ minWidth: 250 }}
									/>}
								</>}
								{!!currentParking.show_pass_in_vehicle_summary && showTilesForEntered && <>
									<VehicleSummaryCard
										title="Pass - Entered"
										value={vehicleSummaryMaskHandler(vehicleSummary.enteredVehiclesPass)}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].enteredPass))}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										loading={loadingVehicleSummary}
										details={false}
										style={{ minWidth: 250 }}
									/>
									<VehicleSummaryCard
										title="Visitor - Entered"
										value={vehicleSummaryMaskHandler(vehicleSummary.enteredVehiclesVisitor)}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].enteredVisitor))}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										loading={loadingVehicleSummary}
										details={false}
										style={{ minWidth: 250 }}
									/>
								</>}
								{!!currentParking.show_pass_in_vehicle_summary && showTilesForExited && <>
									<VehicleSummaryCard
										title="Pass - Exited"
										value={vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesPass)}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedPass))}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										loading={loadingVehicleSummary}
										details={false}
										style={{ minWidth: 250 }}
									/>
									<VehicleSummaryCard
										title="Visitor - Exited"
										value={vehicleSummaryMaskHandler(vehicleSummary.exitedVehiclesVisitor)}
										distributedLabels={summaryVehicleTypes}
										distributedValues={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSummaryMaskHandler(vehicleSummary.vehicleTypes[type].exitedVisitor))}
										distributedIcons={Object.keys(vehicleSummary.vehicleTypes).map(type => vehicleSvgs[type])}
										distributionCount={vehicleTypesCount}
										loading={loadingVehicleSummary}
										details={false}
										style={{ minWidth: 250 }}
									/>
								</>}
							</div>
						</div>}

					{(!reduceSummary || (!(search && search.length > 0 && search.length < 4) && sessionStorage.getItem("hide_summary_search") !== "1")) &&
						<>
							{isSmallDevice ?
								<MuiList>
									{allowCurrentVehiclesUpdate && <EnhancedTableToolbarForMob />}
									{vehicles.map((row, index) => {
										const isItemSelected = isSelected(row.id);
										return (<ListItem alignItems="flex-start" style={{ paddingLeft: 10, paddingRight: 10, borderBottom: "1px solid #18cc69" }}>
											<ListItemAvatar style={{ marginRight: 17, minWidth: 0 }}>
												<Avatar src={vehicleSvgs[row.vehicle_type]} alt={vehicleTypes[row.vehicle_type] ? vehicleTypes[row.vehicle_type].label : ""} style={{ width: 28, height: 28 }} />
											</ListItemAvatar>
											<ListItemText
												primary={hideVehicleNumber(row.license_number)}
												secondary={<div>
													{currentParking.show_amount_in_crm === 1 &&
														displayColumns["Amount"] && <div className="vehicleSummaryMobileViewStyle">
															<div className="vehicleSummaryMobileLabels ">Amount:</div>
															<div style={{ textAlign: "center", display: "flex", gap: 10 }}>
																<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																	{row.total_amount != null && row.total_amount > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.total_amount.toFixed(2))), "Amount")}` : (row.amount_at_entry && row.amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_entry).toFixed(2)), "Amount")}` : "-")}
																	<AddOnServiceTooltip additional_services={row.additional_services} total_amount={row.amount_at_exit}/>
																</div>
																<div>
																	{(currentParking.show_violation_details === 1 && row.violation) || isSurveillanceExit ?
																		<div className="fontWeightBold" style={{ backgroundColor: "#F7685B", color: "#FFFFFF", fontSize: 10, borderRadius: 2, padding: "1px 0px" }}>
																			Violation
																		</div>
																		:
																		row.category ? <div className="fontWeightBold" style={{ display: "flex", justifyContent: "center", alignItems: "center", ...CATEGORIESNEW[row.category].style, fontSize: 10, padding: "1px 0px" }}>
																			<div style={{ flex: 1 }}>{row.category === "IDF" && row.is_commercial === 1 ? "Drop off-C" : row.category === "IDF" && row.is_commercial === 0 ? "Drop off-P" : row.category === "IDF" && (row.is_commercial === null || row.is_commercial === "") ? "Drop off-M" : CATEGORIESNEW[row.category].label}</div>
																			{CATEGORIESNEW[row.category].label === "FOC" &&
																				<Tooltip arrow title={row.remarks ? row.remarks : "No Remarks"} classes={{ tooltip: { fontSize: 10 } }}>
																					<div style={{ alignSelf: "flex-end", backgroundColor: "#5E8DD3", padding: "0px 5px", borderRadius: 2 }}>
																						<img src={sideArrow} alt='arrow' />
																					</div>
																				</Tooltip>}
																		</div> : <div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
																			-
																		</div>
																	}
																</div>
															</div>
														</div>
													}
													{displayColumns["Duration"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Duration:</div>
														<div>{row.exit_time && row.exit_user_id !== "CLEARED" ? moment(row.exit_time).to(row.entry_time, true) : "-"}</div>
													</div>}

													{displayColumns["Entry"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Entry:</div>
														<div>
															{(typeof row.vehicle_entry_image_url === "string" && row.vehicle_entry_image_url !== "") ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={row.vehicle_entry_image_url_thumbnail} record={row} getImages={(record) => {
																let parkingImage = record.vehicle_entry_image_url;
																if (record.parking_images) {
																	const imgs = JSON.parse(record.parking_images);
																	return [...imgs]
																} else {
																	return [parkingImage]
																}
															}} />
																: <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
																	<BrokenImageOutlinedIcon />
																</div>
															}
														</div>
													</div>}
													{displayColumns["Gate"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Gate:</div>
														<div style={{ display: "flex", gap: 10 }}>
															<div>{row.entry_user_id}</div>
															{row.mode_of_payment_at_entry ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																<div className="logsTableDataColor2" style={{ marginRight: 5 }}>{row.mode_of_payment_at_entry === "FASTag" || row.mode_of_payment_at_entry === "ANPR" ? row.mode_of_payment_at_entry : "POS"}</div>
																{row.mode_of_payment_at_entry === "FASTag" &&
																	<Tooltip arrow title={row.fastag_status_at_entry} classes={{ tooltip: classes.tooltip }}><div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[row.fastag_status_at_entry] ? FASTAG_STATUS[row.fastag_status_at_entry].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
																		<div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[row.fastag_status_at_entry] ? FASTAG_STATUS[row.fastag_status_at_entry].color : FASTAG_STATUS["DEFAULT"].color }} />
																	</div></Tooltip>}
																{row.vehicle_type_rc_verified === 1 &&
																	<div style={{ backgroundColor: "#F0F7FF", color: "#BBBBBB", fontSize: 10, borderRadius: 2, padding: "1px 10px" }}>
																		RC Verified
																	</div>
																}
															</div> : <div>-</div>}
														</div>
													</div>}

													{displayColumns["Time"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Time:</div>
														{row.entry_time ? timeFormat("ENTRY", row.entry_time, startDateTime, true)	: <div>-</div>}
													</div>}
													{displayColumns["Payment"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Payment:</div>
														<div style={{ textAlign: "center", display: "flex", gap: 10 }}>
															<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																{row.amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_entry)), "Amount")}` : "-"}
															</div>
															{row.amount_at_entry > 0 && row.mode_of_payment ?
																renderPaymentModeChip(row.mode_of_payment, row.note)
																:
																<div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
																	-
																</div>
															}
														</div>
													</div>}
													{displayColumns["Discount"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Discount:</div>
														<div style={{ textAlign: "center", display: "flex", gap: 10 }}>
															<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																{row.discount_amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.discount_amount_at_entry)), "Amount")}` : "-"}
															</div>
														</div>
													</div>}
													{displayColumns["Device"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Device:</div>
														<div>{row && row.entry_device_id && row.entry_device_id !== "CLEARED" ? row.entry_device_id : "-"}</div>
													</div>}

													{/* Exit Details */}
													{displayColumns["Exit"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Exit:</div>
														<div>
															{((typeof row.vehicle_exit_image_url === "string" && row.vehicle_exit_image_url !== "") || (isSurveillanceExit && typeof row.surveillance_exit_image === "string" && row.surveillance_exit_image !== "")) ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={row.vehicle_exit_image_url_thumbnail} record={row} getImages={(record) => {
																let parkingImage = isSurveillanceExit ? record.surveillance_exit_image : record.vehicle_exit_image_url;
																return [parkingImage];
															}} /> :
																<div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
																	<BrokenImageOutlinedIcon />
																</div>}
														</div>
													</div>}

													{displayColumns["Gate"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Gate:</div>
														<div>
															{isSurveillanceExit ?
																<div style={{ display: "flex", gap: 10 }}>
																	<div>{row.surveillance_exit_user ? row.surveillance_exit_user : "-"}</div>
																	{row.mode_of_payment && row.exit_user_id !== "CLEARED" ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																		<div className="logsTableDataColor2" style={{ marginRight: 5 }}>{row.exit_user_id === 'default' ? "POS" : row.exit_user_id === "" ? "-" : row.mode_of_payment}</div>
																		{row.mode_of_payment === "FASTag" && <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
																			<div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].color : FASTAG_STATUS["DEFAULT"].color }} />
																		</div>}
																	</div> : <div>-</div>}
																	{row.vehicle_type_rc_verified === 1 &&
																			<div style={{ backgroundColor: "#F0F7FF", color: "#BBBBBB", fontSize: 10, borderRadius: 2, padding: "1px 10px" }}>
																				RC Verified
																			</div>
																		}
																</div>
																:
																<div style={{ display: "flex", gap: 10 }}>
																	<div>{row.exit_user_id === "CLEARED" ? "AUTO-EXITED" : row.exit_user_id && row.exit_user_id !== "CLEARED" ? row.exit_user_id : "-"}</div>
																	{row.mode_of_payment && row.exit_user_id !== "CLEARED" ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																		<div className="logsTableDataColor2" style={{ marginRight: 5 }}>{row.mode_of_payment === "FASTag" || row.mode_of_payment === "ANPR" ? row.mode_of_payment : "POS"}</div>
																		{row.mode_of_payment === "FASTag" && <Tooltip arrow title={row.fastag_status_at_exit} classes={{ tooltip: classes.tooltip }}>
																			<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
																				<div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].color : FASTAG_STATUS["DEFAULT"].color }} />
																			</div>
																		</Tooltip>}
																		{row.vehicle_type_rc_verified === 1 &&
																			<div style={{ backgroundColor: "#F0F7FF", color: "#BBBBBB", fontSize: 10, borderRadius: 2, padding: "1px 10px" }}>
																				RC Verified
																			</div>
																		}
																	</div> : <div>-</div>}
																</div>
															}
														</div>
													</div>}

													{displayColumns["Time"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Time:</div>
														{isSurveillanceExit ?
															timeFormat("EXIT", row.surveillance_exit_time, endDateTime, true)
															:
															row.exit_time && row.exit_user_id !== "CLEARED" ? timeFormat("EXIT", row.exit_time, endDateTime, true)
																: <div>-</div>}
													</div>}
													{displayColumns["Payment"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Payment:</div>
														<div style={{ textAlign: "center", display: "flex", gap: 10 }}>
															<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																{row.amount_at_exit > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_exit)), "Amount")}` : "-"}
															</div>
															{row.amount_at_exit > 0 && row.mode_of_payment ?
																renderPaymentModeChip(row.mode_of_payment, row.note)
																:
																<div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
																	-
																</div>
															}
														</div>
													</div>}
													{displayColumns["Discount "] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Discount:</div>
														<div style={{ textAlign: "center", display: "flex", gap: 10 }}>
															<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																{row.discount_amount_at_exit > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.discount_amount_at_exit)), "Amount")}` : "-"}
															</div>
														</div>
													</div>}
													{displayColumns["Device"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Device:</div>
														<div>{row && row.exit_device_id && row.exit_device_id !== "CLEARED" ? row.exit_device_id : "-"}</div>
													</div>}
													{displayColumns["Add On Service"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Add On Service:</div>
														{<AddOnServiceChip additional_services={row.additional_services}/>}
													</div>}
													{displayColumns["Ticket Number"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Ticket Number:</div>
														{row.ticket_number ? <div>{row.ticket_number}</div> : <div>-</div>}
													</div>}
													{displayColumns["Mobile Number"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Mobile Number:</div>
														{row.customer_mobile ? <div>{row.customer_mobile}</div> : <div>-</div>}
													</div>}
													{displayColumns["NFC UID"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">NFC UID:</div>
														{row.nfc_uid && row.nfc_uid.trim() !== "" ? <div>{row.nfc_uid}</div> : <div>-</div>}
													</div>}
													{displayColumns["Serial Number"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Serial Number:</div>
														{row.serial_number && row.serial_number.trim() !== "" ? <div>{row.serial_number}</div> : <div>-</div>}
													</div>}
													{displayColumns["Remarks"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Remarks:</div>
														{row.remarks && row.remarks.trim() !== "" ? <div>{row.remarks}</div> : <div>-</div>}
													</div>}
													{displayColumns["Visit Reason"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Visit Reason:</div>
														{row.visit_reason && row.visit_reason.trim() !== "" ? <div>{row.visit_reason}</div> : <div>-</div>}
													</div>}
													{displayColumns["Visit Destination"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Visit Destination:</div>
														{row.visit_destination && row.visit_destination.trim() !== "" ? <div>{row.visit_destination}</div> : <div>-</div>}
													</div>}
													{displayColumns["Visit Area"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Visit Area:</div>
														{row.zone ? <div>{row.zone}</div> : <div>-</div>}
													</div>}
													{displayColumns["Customer Name"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Customer name:</div>
														{row.customer_name ? <div>{row.customer_name}</div> : <div>-</div>}
													</div>}
													{displayColumns["Customer DOB"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Customer DOB:</div>
														{row.customer_dob ? <div>{row.customer_dob}</div> : <div>-</div>}
													</div>}
													{displayColumns["Driving License"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Driving License:</div>
														{row.customer_driving_license ? <div>{row.customer_driving_license}</div> : <div>-</div>}
													</div>}
													{displayColumns["Chassis"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Chassis:</div>
														{row.chassis_number ? <div>{row.chassis_number}</div> : <div>-</div>}
													</div>}
													{displayColumns["Model"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Model:</div>
														{row.vehicle_make && row.vehicle_model ? <div>{row.vehicle_make} & {row.vehicle_model}</div> : <div>{row.vehicle_make || row.vehicle_model || "-"}</div>}
													</div>}
													{displayColumns["Helmet Cost"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Helmet Cost:</div>
														{row.helmet_cost ? <div>₹ {row.helmet_cost}</div> : <div>-</div>}
													</div>}
													{displayColumns["Violation"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Violation:</div>
														{row.ticket_number ? <div>{row.ticket_number}</div> : <div>-</div>}
													</div>}

													{showDayPassColumn && displayColumns["Day Pass"] && <div className="vehicleSummaryMobileViewStyle">
														<div className="vehicleSummaryMobileLabels">Day Pass:</div>
														{row.day_pass === 1 ? <div>Yes</div> : <div>No</div>}
													</div>}
													{/* {displayColumns["Free Vehicle"] && <>Free Vehicle: <Checkbox color="secondary" disabled={makeExitFree && row.exit_user_id !== 'CLEARED' && row.exit_time ? false : row.entry_user_id !== 'CLEARED' && row.exit_user_id === 'CLEARED'} checked={row.free_vehicle === true || row.free_vehicle === 1 || row.free_vehicle === "true"} onChange={(event, checked) => onFreeVehicleToggle(row.id, checked, row.remarks)} /></>} */}
													{!viewOnly && <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
														{!allowCurrentVehiclesUpdate ? null : <Checkbox color="primary" checked={isItemSelected} onClick={(event) => handleRowSelectMob(event, row.id)} />}
														{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") &&
															<VehicleEdit fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleEntryTime={row.entry_time} vehicleExitTime={row.exit_time} vehicleId={row.id} accessKeyName={record.access_key} oldValues={row} />
														}
														{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales" || sessionStorage.getItem('allow_visitor_delete') === "1") &&
															<VehicleDelete fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleId={row.id} accessKeyName={row.access_key} oldValues={row} />}
													</div>}
												</div>}
											/>
										</ListItem>)
									})}
									<TablePagination
										rowsPerPageOptions={rowsPerPageOptions}
										count={totalVehicleCount}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</MuiList> :
								<Paper style={{ width: "100%", mb: 2, boxShadow: "0px 4px 15px #0000001a" }}>
									<TableContainer component={ScrollableTable} style={{ boxShadow: "none" }}>
										<Table size="small" style={{ padding: 0 }}>
											<TableHead style={{ position: "sticky", top: 0, zIndex: 2, backgroundColor: "#fff" }}>
												<TableRow>
													{Object.keys(displayColumns).map(column => (displayColumns[column] && (currentParking.show_amount_in_crm === 1 || !["Amount", "Entry Amount", "Exit Amount", "Lost Ticket Charges", "Entry Payment Mode", "Exit Payment Mode"].includes(column)) && column !== "Images" && (showSeparateEntryExitImages || !["Entry Image", "Exit Image"].includes(column)) && (showDayPassColumn || !["Day Pass"].includes(column)) && (currentParking.show_violation_details === 1 || !["Violation Image"].includes(column)) &&
														(["Time", "Time "].includes(column) ?
															<StyledTableCell key={column}>
																<div style={{display:"flex", justifyContent:"center", alignItems:"center", cursor:"pointer"}} onClick={() => handleRequestSort(column === "Time" ? "Entry Time" : column === "Time " ? "Exit Time" : column)}>
																	<div>{column}</div>
																	<div style={{marginTop: 5}}>{sortBy === (column === "Time" ? "Entry Time" : column === "Time " ? "Exit Time" : column) && sortOrder === "ASC" && <ArrowUpwardIcon style={{fontSize: 15}}/>} {sortBy === (column === "Time" ? "Entry Time" : column === "Time " ? "Exit Time" : column) && sortOrder === "DESC" && <ArrowDownwardIcon style={{fontSize: 15}}/>}</div>
																</div>
															</StyledTableCell>
															:
															<StyledTableCell key={column}>{column}</StyledTableCell>
														)
													))}
													{/* {(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") && <StyledTableCell >Edit</StyledTableCell>} */}
													{/* {(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") && <StyledTableCell >Delete</StyledTableCell>} */}
												</TableRow>
											</TableHead>
											<TableBody className={!viewOnly ? 'vehicleSummaryFieldDataGrid' : ''}>
												{!loadingVehicles ? vehicles.map((row, index) => {
													return (
														<TableRow key={index} style={{ backgroundColor: currentParking.show_violation_details === 1 && row.violation ? "#FFF4F4" : 'inherit' }}>
															{displayColumns["Type"] && <StyledTableCell><img className={classes.listVehicleIcon} src={vehicleSvgs[row.vehicle_type]} alt={vehicleTypes[row.vehicle_type] ? vehicleTypes[row.vehicle_type].label : ""} title={vehicleTypes[row.vehicle_type] ? vehicleTypes[row.vehicle_type].label : ""} /></StyledTableCell>}
															{displayColumns["Vehicle Number"] && <StyledTableCell component="th" scope="row" className={classes.mainTableCell}><span className='fontWeightSemiBold secondaryColor'>{hideVehicleNumber(row.license_number)}</span></StyledTableCell>}
															{currentParking.show_amount_in_crm === 1 &&
																displayColumns["Amount"] && <StyledTableCell>
																	<div style={{ textAlign: "center" }}>
																		<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																			{row.total_amount != null && row.total_amount > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.total_amount.toFixed(2))), "Amount")}` : (row.amount_at_entry && row.amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_entry).toFixed(2)), "Amount")}` : row.category === "IDF" ? `₹ 0` : "-")}
																			<AddOnServiceTooltip additional_services={row.additional_services} total_amount={row.amount_at_exit}/>
																		</div>
																		<div>
																			{(currentParking.show_violation_details === 1 && row.violation) || isSurveillanceExit ?
																				<div className="fontWeightBold" style={{ backgroundColor: "#F7685B", color: "#FFFFFF", fontSize: 10, borderRadius: 2, padding: "1px 0px" }}>
																					Violation
																				</div>
																				:
																				row.category ? <div className="fontWeightBold" style={{ display: "flex", justifyContent: "center", alignItems: "center", ...CATEGORIESNEW[row.category].style, fontSize: 10, padding: "1px 0px" }}>
																					<div style={{ flex: 1 }}>{row.category === "IDF" && row.is_commercial === 1 ? "Drop off-C" : row.category === "IDF" && row.is_commercial === 0 ? "Drop off-P" : row.category === "IDF" && (row.is_commercial === null || row.is_commercial === "") ? "Drop off-M" : CATEGORIESNEW[row.category].label}</div>
																					{CATEGORIESNEW[row.category].label === "FOC" &&
																						<Tooltip arrow title={row.remarks ? row.remarks : "No Remarks"} classes={{ tooltip: { fontSize: 10 } }}>
																							<div style={{ alignSelf: "flex-end", backgroundColor: "#5E8DD3", padding: "0px 5px", borderRadius: 2 }}>
																								<img src={sideArrow} alt='arrow' />
																							</div>
																						</Tooltip>}
																				</div> : <div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
																					-
																				</div>
																			}
																		</div>
																	</div>
																</StyledTableCell>
															}
															{displayColumns["Duration"] && <StyledTableCell>{row.exit_time && row.exit_user_id !== "CLEARED" ? moment(row.exit_time).to(row.entry_time, true) : "-"}</StyledTableCell>}
															{displayColumns["Entry"] && <StyledTableCell>
																<div>
																	{(typeof row.vehicle_entry_image_url === "string" && row.vehicle_entry_image_url !== "") ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={row.vehicle_entry_image_url_thumbnail} record={row} getImages={(record) => {
																		let parkingImage = record.vehicle_entry_image_url;
																		if (record.parking_images) {
																			const imgs = JSON.parse(record.parking_images);
																			return [...imgs]
																		} else {
																			return [parkingImage]
																		}
																	}} />
																		: <div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
																			<BrokenImageOutlinedIcon />
																		</div>
																	}
																</div>
															</StyledTableCell>}
															{displayColumns["Gate"] && <StyledTableCell>
																<div>
																	<div>{row.entry_user_id}</div>
																	{row.mode_of_payment_at_entry ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																		<div className="logsTableDataColor2" style={{ marginRight: 5 }}>{row.mode_of_payment_at_entry === "FASTag" || row.mode_of_payment_at_entry === "ANPR" ? row.mode_of_payment_at_entry : "POS"}</div>
																		{row.mode_of_payment_at_entry === "FASTag" &&
																			<Tooltip arrow title={row.fastag_status_at_entry} classes={{ tooltip: classes.tooltip }}><div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[row.fastag_status_at_entry] ? FASTAG_STATUS[row.fastag_status_at_entry].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
																				<div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[row.fastag_status_at_entry] ? FASTAG_STATUS[row.fastag_status_at_entry].color : FASTAG_STATUS["DEFAULT"].color }} />
																			</div></Tooltip>}
																		{row.vehicle_type_rc_verified === 1 &&
																			<div style={{ backgroundColor: "#F0F7FF", color: "#BBBBBB", fontSize: 10, borderRadius: 2, padding: "1px 10px" }}>
																				RC Verified
																			</div>
																		}
																	</div> : <div>-</div>}
																</div>
															</StyledTableCell>}

															{displayColumns["Time"] && <StyledTableCell>
																{
																	row.entry_time ? timeFormat("ENTRY", row.entry_time, startDateTime)
																		: <div>-</div>
																}
															</StyledTableCell>}
															{displayColumns["Payment"] && <StyledTableCell>
																<div style={{ textAlign: "center" }}>
																	<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																		{row.amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_entry)), "Amount")}` : "-"}
																	</div>
																	{row.amount_at_entry > 0 && row.mode_of_payment_at_entry ?
																		renderPaymentModeChip(row.mode_of_payment_at_entry)
																		:
																		<div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
																			-
																		</div>
																	}
																</div>
															</StyledTableCell>}
															{displayColumns["Discount"] && <StyledTableCell>
																<div style={{ textAlign: "center" }}>
																	<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																		{row.discount_amount_at_entry > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.discount_amount_at_entry)), "Amount")}` : "-"}
																	</div>
																</div>
															</StyledTableCell>}
															{displayColumns["Device"] && <StyledTableCell>{row && row.entry_device_id && row.entry_device_id !== "CLEARED" ? row.entry_device_id : "-"}</StyledTableCell>}


															{/* Exit Details */}
															{displayColumns["Exit"] && <StyledTableCell>
																<div>
																	{((typeof row.vehicle_exit_image_url === "string" && row.vehicle_exit_image_url !== "") || (isSurveillanceExit && typeof row.surveillance_exit_image === "string" && row.surveillance_exit_image !== "")) ? <ImageGalleryDialogV2 thumbnail={true} thumbnailUrl={row.vehicle_exit_image_url_thumbnail} record={row} getImages={(record) => {
																		let parkingImage = isSurveillanceExit ? record.surveillance_exit_image : record.vehicle_exit_image_url;
																		return [parkingImage];
																	}} /> :
																		<div className='tableDataImg' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
																			<BrokenImageOutlinedIcon />
																		</div>}
																</div>
															</StyledTableCell>}

															{displayColumns["Gate"] && <StyledTableCell>
																<div>
																	{isSurveillanceExit ?
																		<div>
																			<div>{row.surveillance_exit_user ? row.surveillance_exit_user : "-"}</div>
																			{row.mode_of_payment && row.exit_user_id !== "CLEARED" ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																				<div className="logsTableDataColor2" style={{ marginRight: 5 }}>{row.exit_user_id === 'default' ? "POS" : row.exit_user_id === "" ? "-" : row.mode_of_payment}</div>
																				{row.mode_of_payment === "FASTag" && <div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
																					<div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].color : FASTAG_STATUS["DEFAULT"].color }} />
																				</div>}
																				{row.vehicle_type_rc_verified === 1 &&
																					<div style={{ backgroundColor: "#F0F7FF", color: "#BBBBBB", fontSize: 10, borderRadius: 2, padding: "1px 10px" }}>
																						RC Verified
																					</div>
																				}
																			</div> : <div>-</div>}
																		</div>
																		:
																		<div>
																			<div>{row.exit_user_id === "CLEARED" ? "AUTO-EXITED" : row.exit_user_id && row.exit_user_id !== "CLEARED" ? row.exit_user_id : "-"}</div>
																			{row.mode_of_payment && row.exit_user_id !== "CLEARED" ? <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																				<div className="logsTableDataColor2" style={{ marginRight: 5 }}>{row.mode_of_payment === "FASTag" || row.mode_of_payment === "ANPR" ? row.mode_of_payment : "POS"}</div>
																				{row.mode_of_payment === "FASTag" && <Tooltip arrow title={row.fastag_status_at_exit} classes={{ tooltip: classes.tooltip }}>
																					<div style={{ display: 'flex', alignItems: "center", justifyContent: "center", height: 15, width: 15, borderRadius: 20, marginRight: 8, backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].backgroundColor : FASTAG_STATUS["DEFAULT"].backgroundColor }}>
																						<div className={classes.statusCircle} style={{ backgroundColor: FASTAG_STATUS[row.fastag_status_at_exit] ? FASTAG_STATUS[row.fastag_status_at_exit].color : FASTAG_STATUS["DEFAULT"].color }} />
																					</div>
																				</Tooltip>}
																				{row.vehicle_type_rc_verified === 1 &&
																					<div style={{ backgroundColor: "#F0F7FF", color: "#BBBBBB", fontSize: 10, borderRadius: 2, padding: "1px 10px" }}>
																						RC Verified
																					</div>
																				}
																			</div> : <div>-</div>}
																		</div>
																	}
																</div>
															</StyledTableCell>}

															{displayColumns["Time"] && <StyledTableCell>
																{isSurveillanceExit ?
																	timeFormat("EXIT", row.surveillance_exit_time, endDateTime)
																	:
																	row.exit_time && row.exit_user_id !== "CLEARED" ?
																	timeFormat("EXIT", row.exit_time, endDateTime)
																		: <div>-</div>}
															</StyledTableCell>}

															{displayColumns["Payment"] && <StyledTableCell>
																<div style={{ textAlign: "center" }}>
																	<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																		{row.amount_at_exit > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_exit)), "Amount")}` : row.category === "IDF" ? `₹ 0` : "-"}
																	</div>
																	{row.amount_at_exit > 0 && row.mode_of_payment ?
																		renderPaymentModeChip(row.mode_of_payment, row.note)
																		:
																		<div className="fontWeightBold" style={{ color: "#334D6E", backgroundColor: "#EBEFF2", fontSize: 10, borderRadius: 2 }}>
																			-
																		</div>
																	}
																</div>
															</StyledTableCell>}
															{displayColumns["Discount "] && <StyledTableCell>
																<div style={{ textAlign: "center" }}>
																	<div className='fontWeightBold secondaryColor' style={{ fontSize: 12 }}>
																		{row.discount_amount_at_exit > 0 ? `₹ ${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.discount_amount_at_exit)), "Amount")}` : "-"}
																	</div>
																</div>
															</StyledTableCell>}
															{displayColumns["Device"] && <StyledTableCell>{row && row.exit_device_id && row.exit_device_id !== 'CLEARED' ? row.exit_device_id : "-"}</StyledTableCell>}
															{displayColumns["Add On Service"] && <StyledTableCell><AddOnServiceChip additional_services={row.additional_services}/></StyledTableCell>}
															{displayColumns["Ticket Number"] && <StyledTableCell><div>{row?.ticket_number || "-"}</div></StyledTableCell>}
															{/* {displayColumns["Vehicle Image"] && <StyledTableCell>{typeof row.vehicle_image_url === "string" && row.vehicle_image_url !== "" ? <ImageDialog record={row} source="vehicle_image_url" /> : null}</StyledTableCell>} */}
															{displayColumns["Mobile Number"] && <StyledTableCell><div>{row.customer_mobile ? row.customer_mobile : '-'}</div></StyledTableCell>}
															{/* {displayColumns["Entry Time"] && (
														displayColumns["Images"] ?
															<StyledTableCell>
																<div style={{ display: "flex" }}>
																	<div>
																		{(typeof row.vehicle_entry_image_url === "string" && row.vehicle_entry_image_url !== "") ? <ImageGalleryDialog thumbnailStyle={{ height: 40 }} thumbnail={true} record={row} getImages={(record) => {
																			let parkingImage = record.vehicle_entry_image_url;
																			if (record.parking_images) {
																				const imgs = JSON.parse(record.parking_images);
																				return [...imgs]
																			} else {
																				return [parkingImage]
																			}
																		}} />
																			: <div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
																				<BrokenImageOutlinedIcon />
																			</div>}
																	</div>
																	<div style={{ marginLeft: 5 }}>
																		<div>{renderDate(row.entry_time)}</div>
																		<div>{renderTimeV2(row.entry_time)}</div>
																	</div>
																</div>
															</StyledTableCell>
															:
															<StyledTableCell>{renderTime(row.entry_time)}</StyledTableCell>
													)
													} */}
															{/* {displayColumns["Exit Time"] &&
														(displayColumns["Images"] ?
															<StyledTableCell>
																<div style={{ display: "flex" }}>
																	<div>
																		{((typeof row.vehicle_exit_image_url === "string" && row.vehicle_exit_image_url !== "") || (isSurveillanceExit && typeof row.surveillance_exit_image === "string" && row.surveillance_exit_image !== "")) ? <ImageGalleryDialog thumbnailStyle={{ height: 40 }} thumbnail={true} record={row} getImages={(record) => {
																			let parkingImage = isSurveillanceExit ? record.surveillance_exit_image : record.vehicle_exit_image_url;
																			return [parkingImage];
																		}} /> :
																			<div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
																				<BrokenImageOutlinedIcon />
																			</div>}
																	</div>
																	<div style={{ marginLeft: 5 }}>
																		<div>{row.exit_time && row.exit_user_id !== "CLEARED" ? renderDate(row.exit_time) : (isSurveillanceExit ? <div style={{ color: customTheme.palette.error.main }}>{renderDate(row.surveillance_exit_time)}</div> : "-")}</div>
																		<div>
																			{row.exit_time && row.exit_user_id !== "CLEARED" ?
																				renderTimeV2(row.exit_time)
																				: (isSurveillanceExit ?
																					<div style={{ display: "flex" }}>
																						<div style={{ color: customTheme.palette.error.main }}>{renderTimeV2(row.surveillance_exit_time)}</div>
																						<img width={15} height={15} src={CctvImage} alt="cctvImage" style={{ marginLeft: 10 }} />
																					</div>
																					:
																					""
																				)}
																		</div>
																	</div>
																</div>
															</StyledTableCell>
															:
															<StyledTableCell>
																{row.exit_time ? renderTime(row.exit_time) : "-"}
															</StyledTableCell>
														)} */}

															{currentParking.show_amount_in_crm === 1 && <>
																{displayColumns["Total Amount"] && <StyledTableCell>{row.total_amount != null ? `₹${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.total_amount.toFixed(2))), "Amount")}` : (row.amount_at_entry ? `₹${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_entry).toFixed(2)), "Amount")}` : "-")}</StyledTableCell>}
																{displayColumns["Entry Amount"] && <StyledTableCell>{row.amount_at_entry ? `₹${vehicleSummaryMaskHandler(parseFloat(parseFloat(row.amount_at_entry)), "Amount")}` : "-"}</StyledTableCell>}
																{displayColumns["Exit Amount"] && <StyledTableCell>{row.exit_time && row.exit_user_id !== "CLEARED" && row.amount_at_exit ? `₹${vehicleSummaryMaskHandler(parseFloat(row.amount_at_exit), "Amount")}` : "-"}</StyledTableCell>}
																{displayColumns["Lost Ticket Charges"] && <StyledTableCell>{[true, 1, "true", "1"].includes(row.lost_ticket) && row.lost_ticket_cost ? `₹${parseFloat(parseFloat(row.lost_ticket_cost), "Amount")}` : "-"}</StyledTableCell>}
																{/* {displayColumns["Entry Payment Mode"] && <StyledTableCell>
															{(row.amount_at_entry === 0 && ["CASH"].includes(row.mode_of_payment_at_entry)) ?
																<div
																	className={classes.chipCell}
																	style={paymentModeColors[row.mode_of_payment_at_entry] ? { color: paymentModeColors[row.mode_of_payment_at_entry], backgroundColor: (paymentModeColors[row.mode_of_payment_at_entry] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
																>
																	TICKET
																</div>
																:
																<div
																	className={classes.chipCell}
																	style={paymentModeColors[row.mode_of_payment_at_entry] ? { color: paymentModeColors[row.mode_of_payment_at_entry], backgroundColor: (paymentModeColors[row.mode_of_payment_at_entry] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
																>
																	{row.mode_of_payment_at_entry}
																</div>
															}
														</StyledTableCell>} */}

																{/* {displayColumns["Exit Payment Mode"] && <StyledTableCell>
															{((row.amount_at_exit > 0 && row.category === "PAID") || ["FASTag"].includes(row.mode_of_payment)) ?
																<div
																	className={classes.chipCell}
																	style={paymentModeColors[row.mode_of_payment] ? { color: paymentModeColors[row.mode_of_payment], backgroundColor: (paymentModeColors[row.mode_of_payment] + "19") } : { color: "#555555", backgroundColor: "#55555519" }}
																>
																	{row.mode_of_payment}{row.multiple_payments === 1 ? " + CASH" : ""}
																	{row.multiple_payments === 1 ? <WarningRoundedIcon style={{ position: "absolute", top: -6, left: -7, color: "#ffa802" }} /> : null}
																</div>
																:
																"-"
															}

														</StyledTableCell>} */}
															</>}
															{/* displayColumns["Images"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => showSeparateEntryExitImages ? [record.vehicle_image_url] : [record.vehicle_entry_image_url, record.vehicle_exit_image_url, record.vehicle_image_url]} /></StyledTableCell> */}
															{showSeparateEntryExitImages && displayColumns["Entry Image"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => [record.vehicle_entry_image_url]} /></StyledTableCell>}
															{showSeparateEntryExitImages && displayColumns["Exit Image"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => [record.vehicle_exit_image_url]} /></StyledTableCell>}
															{displayColumns["NFC UID"] && <StyledTableCell>{row.nfc_uid}</StyledTableCell>}
															{displayColumns["Serial Number"] && <StyledTableCell>{row.serial_number}</StyledTableCell>}
															{/* {displayColumns["Vehicle Type"] && <StyledTableCell>{row.is_commercial}</StyledTableCell>} */}
															{/* {displayColumns["Category"] && <StyledTableCell style={{ textAlign: "center" }}>
														{row.category ? <div
															className={classes.chipCell}
															style={{ color: customTheme.palette.secondary.main, backgroundColor: customTheme.palette.secondary.main + "20" }}
														>
															{CATEGORIES[row.category]}
														</div> : ""}
														{[true, 1, "true", "1"].includes(row.lost_ticket) ? <div style={{ marginTop: 4, fontSize: 13, color: "#777" }}>Lost Ticket</div> : null}
													</StyledTableCell>} */}
															{/* {displayColumns["Entry User"] && <StyledTableCell style={{ textAlign: "center" }}><div style={{ color: "#727272" }}>{row.entry_user_id}</div>{row.entry_device_id && <div style={{ marginTop: 1 }}>{row.entry_device_id}</div>}</StyledTableCell>} */}
															{/* {displayColumns["Exit User"] && <StyledTableCell style={{ textAlign: "center" }}>{isSurveillanceExit ? <div style={{ color: customTheme.palette.error.main }}>{row.surveillance_exit_user}</div> : (row.exit_user_id !== "CLEARED" ? <><div style={{ color: "#727272" }}>{row.exit_user_id}</div>{row.exit_device_id && <div style={{ marginTop: 1 }}>{row.exit_device_id}</div>}</> : "-")}</StyledTableCell>} */}
															{/* {displayColumns["FASTag Entry Status"] && <StyledTableCell>{row.fastag_status_at_entry}</StyledTableCell>} */}
															{/* {displayColumns["FASTag Exit Status"] && <StyledTableCell>{row.fastag_status_at_exit}</StyledTableCell>} */}
															{displayColumns["Remarks"] && <StyledTableCell>{row.remarks}</StyledTableCell>}
															{currentParking.show_violation_details === 1 && displayColumns["Violation"] && <StyledTableCell>{row.violation}</StyledTableCell>}
															{/* {currentParking.show_violation_details === 1 && displayColumns["Violation Factor"] && <StyledTableCell>{row.violation_factor}</StyledTableCell>} */}
															{currentParking.show_violation_details === 1 && displayColumns["Violation Image"] && <StyledTableCell><ImageGalleryDialog record={row} getImages={record => [record.violation_image]} /></StyledTableCell>}
															{showDayPassColumn && displayColumns["Day Pass"] && <StyledTableCell>{row.day_pass === 1 ? "Yes" : "No"}</StyledTableCell>}
															{displayColumns["Visit Reason"] && <StyledTableCell>{row.visit_reason}</StyledTableCell>}
															{displayColumns["Visit Destination"] && <StyledTableCell>{row.visit_destination}</StyledTableCell>}
															{displayColumns["Visit Area"] && <StyledTableCell>{row.zone ? row.zone : '-'}</StyledTableCell>}
															{displayColumns["Customer Name"] && <StyledTableCell>{row.customer_name ? row.customer_name : '-'}</StyledTableCell>}
															{displayColumns["Customer DOB"] && <StyledTableCell>{row.customer_dob ? row.customer_dob : '-'}</StyledTableCell>}
															{displayColumns["Driving License"] && <StyledTableCell>{row.customer_driving_license ? row.customer_driving_license : '-'}</StyledTableCell>}
															{displayColumns["Chassis"] && <StyledTableCell>{row.chassis_number ? row.chassis_number : '-'}</StyledTableCell>}
															{displayColumns["Model"] && <StyledTableCell>{row.vehicle_make && row.vehicle_model ? `${row.vehicle_make} - ${row.vehicle_model}` : row.vehicle_make || row.vehicle_model || '-'}</StyledTableCell>}
															{displayColumns["Helmet Cost"] && <StyledTableCell>{row.helmet_cost ? `₹${row.helmet_cost}` : '-'}</StyledTableCell>}
															{displayColumns["Violation"] && <StyledTableCell><div>{row?.violation || "-"}</div></StyledTableCell>}
															{!viewOnly && <StyledTableCell className='ListIconsContainerVehicleSummaryFieldData'>
																<div className="ListIcons">
																	{!allowCurrentVehiclesUpdate || isSurveillanceExit ? null : <VehicleMakeFreeOrPaid data={row} />}
																	{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales") &&
																		<VehicleEdit fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleEntryTime={row.entry_time} vehicleExitTime={row.exit_time} vehicleId={row.id} accessKeyName={row.access_key} oldValues={row} />
																	}
																	{(sessionStorage.getItem('role') === "admin" || sessionStorage.getItem('role') === "sales" || sessionStorage.getItem('allow_visitor_delete') === "1") && <VehicleDelete fetchSummary={() => fetchSummary()} licenseNumber={row.license_number} vehicleId={row.id} accessKeyName={row.access_key} oldValues={row} />}
																</div>
															</StyledTableCell>}

														</TableRow>
													);
												})
													:
													<TableRowsLoader rowsNum={5} />
												}
											</TableBody>
										</Table>
									</TableContainer>
									<TablePagination
										rowsPerPageOptions={rowsPerPageOptions}
										count={totalVehicleCount}
										rowsPerPage={rowsPerPage}
										page={page}
										onChangePage={handleChangePage}
										onChangeRowsPerPage={handleChangeRowsPerPage}
									/>
								</Paper>
							}
						</>}
				</>

			}

			<Portal>
				<Dialog
					fullWidth
					onClose={hideFreeVehicleConfirmation}
					open={freeVehicleConfirmation != null}
				>
					<DialogContent>
						<div>
							<FormControl>
								<FormLabel>FOC Reason</FormLabel>
								<RadioGroup
									value={focType}
									onChange={(e) => onFocTypeChange(e)}
								>
									<FormControlLabel value="Police vehicle" control={<Radio />} label="Police vehicle" />
									<FormControlLabel value="Noida Authority Vehicle" control={<Radio />} label="Noida Authority Vehicle" />
									<FormControlLabel value="Government Vehicle" control={<Radio />} label="Government Vehicle" />
									<FormControlLabel value="MG Infra Associate" control={<Radio />} label="MG Infra Associate" />
									<FormControlLabel value="Management" control={<Radio />} label="Management" />
								</RadioGroup>

								<DialogContentText style={{ marginTop: 5 }}>If other than above mentioned reason then you may edit the remarks field.</DialogContentText>
							</FormControl>
						</div>

						<div>
							<MuiTextField
								autoFocus
								multiline
								rowsMax={3}
								margin="dense"
								variant="outlined"
								label="Remarks*"
								value={freeVehicleConfirmation && freeVehicleConfirmation.remarks ? freeVehicleConfirmation.remarks : ""}
								onChange={event => {
									setFreeVehicleConfirmation({ ...freeVehicleConfirmation, remarks: event.target.value });
								}}
							/>
							{makeExitFree && freeVehicleConfirmation && !freeVehicleConfirmation.free &&
								<MuiTextField
									autoFocus
									multiline
									rowsMax={3}
									margin="dense"
									variant="outlined"
									label="Amount*"
									value={freeVehicleConfirmation && freeVehicleConfirmation.make_paid_amount ? freeVehicleConfirmation.make_paid_amount : ""}
									onChange={event => {
										if (event.target.value && !isNaN(event.target.value)) {
											setFreeVehicleConfirmation({ ...freeVehicleConfirmation, make_paid_amount: event.target.value });
										}
									}}
									onKeyDown={(e) => {
										if (e.code === 'Space') e.preventDefault()
									}}
									style={{ marginLeft: 20 }}
								/>}
						</div>

						<DialogContentText style={{ marginTop: 20 }}>
							Are you sure you want to mark it as <b style={{ color: "#334D6E" }}>{freeVehicleConfirmation && freeVehicleConfirmation.free ? "Free" : "Paid"} Vehicle</b>?
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={hideFreeVehicleConfirmation} color="default">Cancel</Button>
						<Button onClick={toggleFreeVehicle} color="primary">Make {freeVehicleConfirmation && freeVehicleConfirmation.free ? "Free" : "Paid"}{freeVehicleConfirmation && freeVehicleConfirmation.loading && <CircularProgress size={20} style={{ marginLeft: 5 }} />}</Button>
					</DialogActions>
				</Dialog>
			</Portal>
		</div>
	);
};

const ParkingShow = (props) => {
	const classes = useStyles();

	return (
		<Show className="vehicleSummaryLayout" {...props} actions={null} component={props => <Box {...props} style={{ width: "100%" }} />} classes={{ main: classes.removeMargin }}>
			<SimpleShowLayout>
				<VehicleSummary />
			</SimpleShowLayout>
		</Show>
	)
};
export default ParkingShow;

function VehicleEdit({ fetchSummary, licenseNumber, vehicleEntryTime, vehicleExitTime, vehicleId, accessKeyName, oldValues }) {
	const classes = useStyles();
	//const notify = useNotify()
	const [vehicleDialogVisible, setVehicleDialogVisible] = useState(false);
	const [loading, setLoading] = useState(false)
	const [vehicleNumber, setVehicleNumber] = useState(licenseNumber)
	const [entryTime, setEntryTime] = useState(vehicleEntryTime)
	const [exitTime, setExitTime] = useState(vehicleExitTime)

	let newData = {
		vehicle_number: vehicleNumber,
		entry_time: moment(entryTime).utcOffset('+05:30').format("YYYY-MM-DD HH:mm:ss"),
		exit_time: moment(exitTime).utcOffset('+05:30').format("YYYY-MM-DD HH:mm:ss")
	}
	let oldData = {
		...oldValues
	}

	const handleClose = () => setVehicleDialogVisible(false)
	const handleOpen = () => setVehicleDialogVisible(true)

	const onSubmitHandler = () => {
		const requestBody = {
			method: 'POST',
			headers: {
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ newData, oldData, access_key: accessKeyName })
		};
		fetch(`${config.HOST_NAME}/crm/v3/vehicleSummary/updateVehicle/${vehicleId}`, requestBody)
			.then((res) => {
				saveTokens(res)
				return res.json()
			})
			.then((response) => {
				if (response.success) {
					setLoading(false)
					notify("Vehicle Updated Successfully", 'success')
					handleClose()
					fetchSummary()
				} else {
					setLoading(false)
					notify(response.message, 'warning')
				}
			})
			.catch((error) => {
				console.log(error)
				notify("Something went wrong", 'warning')
			})
	}

	return (
		<>
			<RaButton style={{ color: "#18cc69" }} onClick={handleOpen}><EditIcon /></RaButton>

			<Dialog
				open={vehicleDialogVisible}
				onClose={handleClose}
				fullWidth
				classes={{ paper: classes.dialogPaper }}
				BackdropProps={{
					classes: {
						root: classes.backDrop
					}
				}}
			>
				<DialogContent>

					<MuiTextField label="Vehicle Number" variant='outlined' value={vehicleNumber} onChange={(e) => setVehicleNumber(e.target.value)} size="small" style={{ display: "block" }} />

					<MuiPickersUtilsProvider utils={DateFnsUtils}>

						<DateTimePicker
							disableFuture
							ampm
							value={entryTime}
							onChange={datetime => setEntryTime(datetime)}
							label="Entry Time"
							inputVariant="outlined"
							TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
							ToolbarComponent={DateTimePickerToolbar}
							format="dd/MM/yyyy hh:mm a"
							style={{ display: "block", marginTop: "20px" }}
						/>
						<DateTimePicker
							disableFuture
							ampm
							value={exitTime}
							onChange={datetime => setExitTime(datetime)}
							label="Exit Time"
							inputVariant="outlined"
							TextFieldComponent={(props) => <MuiTextField {...props} size="small" />}
							ToolbarComponent={DateTimePickerToolbar}
							format="dd/MM/yyyy hh:mm a"
							style={{ marginTop: "20px" }}
						/>

					</MuiPickersUtilsProvider>

				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
						Close
					</Button>
					<Button onClick={onSubmitHandler} color="primary" variant='contained' style={{ backgroundColor: '#18cc69', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
						Save {loading && <CircularProgress size={25} style={{ marginLeft: "10px", color: "#FFF" }} />}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

function VehicleDelete({ fetchSummary, licenseNumber, vehicleId, accessKeyName, oldValues }) {
	const classes = useStyles();
	//const notify = useNotify();
	const [vehicleDeleteDialogVisible, setVehicleDeleteDialogVisible] = useState(false);
	const [loading, setLoading] = useState(false)

	let oldData = {
		...oldValues
	}

	const handleCloseDelete = () => setVehicleDeleteDialogVisible(false)
	const handleOpenDelete = () => setVehicleDeleteDialogVisible(true)
	const onSubmitHandler = () => {
		const requestBody = {
			method: 'DELETE',
			headers: {
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
				'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ vehicle_number: licenseNumber, access_key: accessKeyName, oldData })
		};
		fetch(`${config.HOST_NAME}/crm/v3/vehicleSummary/deleteVehicle/${vehicleId}`, requestBody)
			.then((res) => {
				saveTokens(res)
				return res.json()
			})
			.then((response) => {
				if (response.success) {
					setLoading(false)
					notify("Vehicle Deleted Successfully", 'success')
					handleCloseDelete()
					fetchSummary()
				} else {
					setLoading(false)
					notify(response.message, 'warning')
				}
			})
			.catch((error) => {
				console.log(error)
				notify("Something went wrong", 'warning')
			})
	}

	return (
		<>
			<RaButton style={{ color: '#de575e' }} onClick={handleOpenDelete}><DeleteIcon /></RaButton>

			<Dialog
				open={vehicleDeleteDialogVisible}
				onClose={handleCloseDelete}
				fullWidth
				classes={{ paper: classes.dialogPaper }}
				BackdropProps={{
					classes: {
						root: classes.backDrop
					}
				}}
			>
				<DialogContent>

					<DialogContentText id="alert-dialog-description">
						Are you sure you want to <strong>Delete</strong> this vehicle.
					</DialogContentText>

				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseDelete} color="error" variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E" }} disableElevation>
						Close
					</Button>
					<Button onClick={onSubmitHandler} color="primary" variant='contained' style={{ backgroundColor: '#de575e', color: "#FFF", textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "40px", minWidth: "120px", }} autoFocus disableElevation>
						Delete {loading && <CircularProgress size={25} style={{ marginLeft: "10px", color: "#FFF" }} />}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

// eslint-disable-next-line no-unused-vars
function CheckVehicleExited({ row }) {
	const classes = useStyles();
	const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
	const [dialogVisible, setDialogVisible] = useState(false);
	const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
	const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

	const renderTime = time => {
		const secondsFormat = showTimeTillSeconds ? ":ss" : "";
		return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY ${use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`}`);
	};

	const handleClose = () => setDialogVisible(false)
	const handleOpen = () => setDialogVisible(true)

	return (
		<>
			<div title="Check Vehicle Exit" style={{ color: customTheme.palette.error.main, cursor: 'pointer', fontSize: 14 }} onClick={handleOpen}>
				{
					!isSmallDevice ?
						<div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
							<img width={15} height={15} src={CctvImage} alt="cctvImage" style={{ marginRight: 10 }} />
							<p>Exited</p>
						</div>
						: <span>Exited</span>
				}
			</div>
			<Dialog
				open={dialogVisible}
				onClose={handleClose}
				classes={{ paper: classes.dialogPaper }}
				BackdropProps={{
					classes: {
						root: classes.backDrop
					}
				}}
			>
				<DialogContent>
					<p style={{ fontWeight: 'bold', fontSize: 14, lineHeight: '1px' }}>Surveillance Details</p>

					<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch', columnGap: 10, flexWrap: 'wrap', borderRadius: 10 }}>
						<div>
							<div style={{ marginBottom: 20 }}>
								<p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>VEHICLE NUMBER</p>
								<p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{row.license_number}</p>
							</div>
							<div style={{ marginBottom: 20 }}>
								<p style={{ fontSize: 12, lineHeight: "3px", color: '#9899A1' }}>Exit Time</p>
								<p style={{ fontSize: 14, color: '#272727', lineHeight: "3px", fontWeight: '600' }}>{renderTime(row.surveillance_exit_time)}</p>
							</div>
						</div>

						<div>
							{row.surveillance_exit_image ?
								<ImageGalleryDialog
									thumbnail={true}
									record={row}
									style={{ textAlign: isSmallDevice ? 'left' : 'right' }}
									getImages={(record) => [record.surveillance_exit_image]}
								/>
								:
								<div style={{ display: isSmallDevice ? 'block' : "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
									<div style={{ display: "flex", justifyContent: "center", alignItems: "center", border: "1px solid #BDBDBD", minWidth: "50px", width: "60px", borderRadius: 5, height: "40px" }}>
										<BrokenImageOutlinedIcon />
									</div>
								</div>
							}
						</div>
					</div>
				</DialogContent>

				<DialogActions>
					<Button onClick={handleClose} variant='contained' style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", height: "35px", minWidth: "120px", backgroundColor: "#E7EBF0", color: "#334D6E", marginRight: 10 }} disableElevation>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
}

const DevicesUnderParking = ({ devices, totalDevicesAmount, serialNumberToFilter, setSerialNumberToFilter, loading }) => {
	const classes = useStyles();
	const donutColors = ['#FC7668', '#3EF791', '#FFCBA5', '#FFA7A6', '#92EEFC', '#5E8DD3', '#FFA726']

	const [selectedDevice, setSelectedDevice] = useState(null)

	useEffect(() => {
		if (selectedDevice != null) setSerialNumberToFilter(selectedDevice.serial_number)
		else setSerialNumberToFilter('All')

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedDevice])
	return <Paper style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', boxShadow: "0px 4px 15px #0000001a", padding: "14px 20px" }}>

		<div style={{ flex: 2 }}>
			<div>
				<Typography className={classes.title}>Devices</Typography>
				{!loading ? <Typography className={classes.mainValue}>{selectedDevice ? selectedDevice.serial_number : devices.length}</Typography>
					:
					<Skeleton variant="text" height={36} width="34%" />}
			</div>

			<div style={{ marginTop: 25 }}>
				<Typography className={classes.summaryBoxLabel2}>Amount</Typography>
				{!loading ? <Typography className={classes.summaryBoxValue2}>₹ {selectedDevice ? selectedDevice.amount.toFixed(2) : totalDevicesAmount ? totalDevicesAmount.toFixed(2) : '0.00'}</Typography>
					: <Skeleton variant="text" height={36} width="34%" />}
			</div>
		</div>

		<div>


			<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flex: 1, width: '150px' }}>
				<ReactApexChart
					series={devices[0] ? [...devices.filter((val) => val.amount > 0).map((val) => val.amount)] : [1]}
					type="donut"
					height='120'
					widht='120'
					options={{
						dataLabels: {
							enabled: false
						},
						colors: devices[0] ? [...donutColors] : ['#F4F4F4'],
						chart: {
							type: 'donut',
							fontFamily: "Poppins-Regular",
							events: {
								dataPointSelection: (event, chartContext, config) => {
									let filteredDeivces = devices.filter((val) => val.amount > 0).map((val) => val)
									setSelectedDevice((prev) => {
										if (prev && filteredDeivces[config.dataPointIndex].serial_number === prev.serial_number) {
											return null
										} else return filteredDeivces[config.dataPointIndex]
									})
								}
							}
						},
						legend: {
							show: false
						},
						tooltip: {
							enabled: true,
							style: {
								fontSize: '12px',
								fontFamily: "Poppins-Regular"
							},
							marker: {
								show: true,
							},
							custom: function ({ series, seriesIndex, dataPointIndex, w }) {
								// let total = 0;
								// for (let x of series) {
								// 	total += x;
								// }
								let selected = series[seriesIndex]
								//distributedLabels[seriesIndex] + ": " + selected + "(" + (selected / total * 100).toFixed(2) + "%)" + distributedAmount[seriesIndex]
								let deviceName = devices[seriesIndex].unique_user_id ? devices[seriesIndex].unique_user_id : devices[seriesIndex].serial_number
								return devices[0] ? `${deviceName}: ${selected} | Amount : ₹ ${devices[seriesIndex].amount}` : ''
							}
						}
					}}
				/>
				{devices[0] ? <div style={{ display: 'flex', flexWrap: 'wrap', fontSize: 10, lineHeight: '1px', color: '#9e9e9e' }}>
					{devices.filter((val) => val.amount > 0).map((device, i) => (
						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: 10 }}>
							<div style={{ backgroundColor: donutColors[i], width: 6, height: 6, borderRadius: 100, marginRight: 5 }}></div>
							<p>{device.serial_number}</p>
						</div>
					))}
				</div>
					:
					<p style={{ fontSize: 10, color: '#9e9e9e' }}>Data not available.</p>}
			</div>
		</div>

	</Paper>


}

const AntSwitch = withStyles((theme) => ({
	root: {
		width: 28,
		height: 15,
		padding: 0,
		display: 'flex',
	},
	switchBase: {
		padding: 2,
		color: theme.palette.grey[500],
		'&$checked': {
			transform: 'translateX(12px)',
			color: theme.palette.common.white,
			'& + $track': {
				opacity: 1,
				backgroundColor: theme.palette.primary.main,
				borderColor: theme.palette.primary.main,
			},
		},
	},
	thumb: {
		width: 11,
		height: 11,
		boxShadow: 'none',
	},
	track: {
		border: `1px solid ${theme.palette.grey[500]}`,
		borderRadius: 16 / 2,
		opacity: 1,
		backgroundColor: theme.palette.common.white,
		height: "auto",
		paddingTop: 2,
		paddingBottom: 2
	},
	checked: {},
}))(Switch);

const WhiteTooltip = withStyles({
  tooltip: {
    backgroundColor: '#fff',
    color: 'black',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    fontSize: 14,
    borderRadius: 8,
    padding: '8px 12px',
    textAlign: 'center',
  },
  arrow: {
    color: '#fff',
  },
})(Tooltip);

const AddOnServiceTooltip = ({ additional_services, total_amount = 0 }) => {
	const isValidArray = Array.isArray(additional_services) && additional_services.length > 0;
  
	if (!isValidArray) return null;
  
	const additionalTotal = additional_services.reduce((acc, item) => acc + item.amount, 0);
	const showParking = total_amount > 0;
	const parkingAmount = showParking ? total_amount - additionalTotal : 0;
  
	return (
	  <WhiteTooltip
		title={
		  <div>
			<div style={{ fontWeight: 'normal', fontSize: '12px' }}>
			  {additional_services.map((service, index) => (
				<span key={service.id}>
				  ₹{service.amount}
				  {index < additional_services.length - 1 && <>&nbsp;+&nbsp;</>}
				</span>
			  ))}
			  {showParking && additional_services.length > 0 && <>&nbsp;+&nbsp;</>}
			  {showParking && <>₹{parkingAmount}</>}
			</div>
			<div style={{ color: '#888', fontSize: '10px', fontWeight: 'normal' }}>
			  {additional_services.map((service, index) => (
				<span key={service.id}>
				  ({service.name})
				  {index < additional_services.length - 1 && <>&nbsp;</>}
				</span>
			  ))}
			  {showParking && additional_services.length > 0 && <>&nbsp;</>}
			  {showParking && <>(Parking)</>}
			</div>
		  </div>
		}
		arrow
		placement="top"
	  >
		<IconButton
		  style={{
			padding: 2,
			width: 18,
			height: 18,
		  }}
		>
		  <InfoOutlinedIcon style={{ fontSize: 12 }} />
		</IconButton>
	  </WhiteTooltip>
	);
  };

  const AddOnServiceChip = ({additional_services}) => {
	const isValidArray = Array.isArray(additional_services) && additional_services.length > 0;
	if (!isValidArray) return "-";

	return (
		<div style={{ color: '#888', fontSize: '10px', fontWeight: 'normal' }}>
		{additional_services.map((service, index) => (
		  <span key={service.id} style={{marginRight:"2px", backgroundColor:"#F0F7FF", color:"#086FC1", borderRadius:"5px", fontSize:"10px", padding:"2px 4px"}}>
			{service.name}
		  </span>
		))}
	  </div>
	);
  };
  
  